<template>
  <div class="page-wrapper" :class="mode === 'form' ? 'page-wrapper--form' : 'page-wrapper--list'">
    <PageShell :system-title="systemTitle" :breadcrumbs="breadcrumbs" :show-header="false" :show-breadcrumb="false">
      <TableListShell
        v-show="mode === 'list'"
        embedded
        :page="page"
        :min-table-width="'1000px'"
        @page-change="changePage"
        @size-change="changeSize"
      >
        <template #filter>
          <div v-if="props.formCode === 'Product'" class="tabs-row">
          <el-tabs v-model="productActiveTab" class="line-status-tabs" @tab-click="handleProductTabClick">
            <el-tab-pane label="审核中" name="review" />
            <el-tab-pane label="售卖中" name="selling" />
            <el-tab-pane label="审核驳回" name="rejected" />
            <el-tab-pane label="已下架" name="archived" />
            <el-tab-pane label="草稿" name="draft" />
          </el-tabs>
        </div>
        <div v-if="showLotteryTabs" class="tabs-row">
          <el-tabs v-model="lotteryActiveTab" class="line-status-tabs" @tab-click="handleLotteryTabClick">
            <el-tab-pane label="抽奖" name="lottery" />
            <el-tab-pane label="新品体验馆" name="experience" />
          </el-tabs>
        </div>
        <div v-if="showLotteryStatusTabs" class="tabs-row">
          <el-tabs
            :key="`lottery-status-${currentLotteryDrawType}`"
            v-model="lotteryStatusTab"
            class="line-status-tabs"
            @tab-click="handleLotteryStatusTabClick"
          >
            <el-tab-pane
              v-for="tab in lotteryStatusTabOptions"
              :key="tab.name"
              :label="tab.label"
              :name="tab.name"
            />
          </el-tabs>
        </div>
        <div v-if="showOrderTabs" class="tabs-row">
          <el-tabs v-model="orderActiveTab" class="line-status-tabs" @tab-click="handleOrderTabClick">
            <el-tab-pane label="全部" name="all" />
            <el-tab-pane label="待支付" name="pendingPay" />
            <el-tab-pane label="待发货" name="pendingShip" />
            <el-tab-pane label="待收货" name="pendingReceive" />
            <el-tab-pane label="已签收" name="signed" />
          </el-tabs>
        </div>
        <div v-if="showLotteryOrderTabs" class="tabs-row">
          <el-tabs v-model="lotteryOrderTab" class="line-status-tabs" @tab-click="handleLotteryOrderTabClick">
            <el-tab-pane label="全部" name="all" />
            <el-tab-pane label="未发货" name="pendingShip" />
            <el-tab-pane label="已发货" name="shipped" />
          </el-tabs>
        </div>
        <div v-if="showCommonStatusTabs" class="tabs-row">
          <el-tabs v-model="commonStatusTab" class="line-status-tabs" @tab-click="handleCommonStatusTabClick">
            <el-tab-pane label="全部" name="all" />
            <el-tab-pane label="已上架" name="published" />
            <el-tab-pane label="草稿" name="draft" />
          </el-tabs>
        </div>
        <ListFilterPanel :visible="filterVisible" @apply="applyFilters" @reset="resetDraftFilters">
          <div v-if="showConfigSelect" class="list-filter-panel__item">
            <span class="list-filter-panel__label">配置</span>
            <el-select v-model="draftSelectedConfigId" placeholder="请选择表单配置" size="small" clearable>
              <el-option v-for="cfg in formConfigs" :key="cfg.id" :label="cfg.name" :value="cfg.id" />
            </el-select>
          </div>
          <div class="list-filter-panel__item">
            <span class="list-filter-panel__label">关键词</span>
            <el-input v-model="draftKeyword" :placeholder="`搜索${schema.title || ''}`" clearable size="small" />
          </div>
          <div v-if="props.formCode === 'Product'" class="list-filter-panel__item">
            <span class="list-filter-panel__label">商品编码</span>
            <el-input v-model="draftProductCode" placeholder="商品编码" clearable size="small" />
          </div>
          <div v-if="props.formCode === 'Product'" class="list-filter-panel__item">
            <span class="list-filter-panel__label">商品名称</span>
            <el-input v-model="draftProductName" placeholder="商品名称" clearable size="small" />
          </div>
          <div v-if="props.formCode === 'Product'" class="list-filter-panel__item">
            <span class="list-filter-panel__label">商品类型</span>
            <el-select v-model="draftProductType" placeholder="商品类型" clearable size="small">
              <el-option v-for="item in productTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </div>
          <div v-if="showProductDesignerQuery" class="list-filter-panel__item">
            <span class="list-filter-panel__label">设计师查询</span>
            <el-select
              v-model="draftDesignerQuery"
              placeholder="请选择设计师"
              clearable
              filterable
              remote
              :remote-method="searchProductDesigners"
              :loading="productDesignerOptionsLoading"
              size="small"
              @visible-change="handleProductDesignerVisibleChange"
            >
              <el-option
                v-for="item in productDesignerOptions"
                :key="item.id"
                :label="productDesignerDisplayName(item)"
                :value="item.id"
              />
            </el-select>
          </div>
        </ListFilterPanel>
        </template>
        <template #actions>
          <div class="toolbar-actions">
            <ListFilterToggle :active="filterVisible" @toggle="toggleFilter" />
            <el-button
              v-if="props.formCode === 'QrcodeBatch'"
              size="small"
              type="success"
              @click="handleBatchCreateFromCards"
            >一键生成卡片批次</el-button>
            <el-dropdown v-if="props.formCode === 'Product'" @command="handleAddProduct">
              <el-button size="small" type="primary">
                发布商品<el-icon class="el-icon--right"><arrow-down /></el-icon>
              </el-button>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item v-for="item in productTypeOptions" :key="item.value" :command="item.value">
                    发布{{ item.label }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
            <el-button v-else size="small" type="primary" @click="handleAdd">新增</el-button>
            <el-button size="small" :disabled="!current" @click="handleEdit">修改</el-button>
            <el-button
              v-if="props.formCode === 'Admin'"
              size="small"
              type="success"
              :disabled="!selectedIds.length"
              @click="openRoleAssign"
            >角色分配</el-button>
            <el-button
              v-if="isAccountForm"
              size="small"
              type="warning"
              :disabled="!selectedIds.length"
              @click="handleResetPassword"
            >重置密码</el-button>
            <el-button size="small" type="danger" :disabled="!selectedIds.length" @click="handleRemove">删除</el-button>
            <el-button size="small" @click="loadData">刷新</el-button>
            <el-button
              v-if="props.formCode === 'ProductModule'"
              size="small"
              type="success"
              :loading="productModuleSyncLoading"
              @click="handleSyncProductModule"
            >同步商品数据</el-button>
          </div>
        </template>
        <template #table="{ tableHeight }">
          <el-table
            v-loading="loading && !isTypeBoundForm"
            :data="tableData"
            border
            :height="tableHeight"
            @selection-change="onSelectionChange"
            @header-dragend="handleListColumnResize"
            :highlight-current-row="false"
          >
            <el-table-column type="selection" width="48" fixed="left" />
            <template v-if="isTypeBoundForm">
              <el-table-column label="商品信息" min-width="320">
                <template #default="{ row }">
                  <div class="product-info-cell">
                    <div class="product-info-cell__media">
                      <div
                        v-if="productRowImage(row)"
                        class="product-list-thumb-wrap"
                        @click="openProductImagePreview(row)"
                      >
                        <img
                          :src="normalizeImgUrl(productRowImage(row))"
                          alt=""
                          class="product-list-thumb"
                          loading="lazy"
                          decoding="async"
                          fetchpriority="low"
                        />
                        <div class="product-list-thumb__mask">
                          <el-icon class="product-list-thumb__icon"><View /></el-icon>
                        </div>
                      </div>
                      <span v-else class="product-list-thumb--empty">无图</span>
                    </div>
                    <div class="product-info-cell__body">
                      <div class="product-info-cell__name" :title="productRowName(row)">
                        {{ productRowName(row) }}
                      </div>
                      <div class="product-info-cell__code-row">
                        <span class="product-info-cell__code">商品编码：{{ productRowCode(row) }}</span>
                        <button
                          v-if="row?.code"
                          type="button"
                          class="product-info-cell__copy"
                          title="复制商品编码"
                          @click.stop="copyProductCode(row)"
                        >
                          <el-icon><DocumentCopy /></el-icon>
                        </button>
                      </div>
                      <button
                        type="button"
                        class="product-info-cell__preview"
                        @click="handleProductDetailPreview(row)"
                      >
                        预览 &gt;
                      </button>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="商品类型" width="100" align="center" show-overflow-tooltip>
                <template #default="{ row }">
                  {{ productRowTypeLabel(row) }}
                </template>
              </el-table-column>
              <el-table-column label="规格价格" width="120" align="right">
                <template #default="{ row }">
                  {{ formatProductPrice(row.price) }}
                </template>
              </el-table-column>
              <el-table-column label="库存" width="100" align="center">
                <template #default="{ row }">
                  {{ productRowStock(row) }}
                </template>
              </el-table-column>
              <el-table-column label="近30天销量" width="140" align="center">
                <template #default="{ row }">
                  <div class="product-sales-cell">
                    <div class="product-sales-cell__main">{{ productRowSales30d(row) }}</div>
                    <div class="product-sales-cell__sub">历史累计：{{ productRowHistorySales(row) }}</div>
                  </div>
                </template>
              </el-table-column>
            </template>
            <template v-else>
              <el-table-column type="index" label="序号" width="60" />
              <el-table-column
                v-for="col in schema.columns"
                :key="col.prop"
                :prop="col.prop"
                :label="col.label"
                :width="resolveListColumnWidth(col)"
              >
                <template #default="scope">
                  <template v-if="isImageLikeCell(col, scope.row)">
                    <el-image
                      v-if="columnValue(col, scope.row)"
                      :src="normalizeImgUrl(columnValue(col, scope.row))"
                      fit="cover"
                      lazy
                      style="width: 46px; height: 46px; border-radius: 6px; border: 1px solid #f0f0f0; cursor: pointer"
                      @click.stop="openImagePreview(columnValue(col, scope.row))"
                    />
                    <span v-else>-</span>
                  </template>
                  <template v-else-if="isWebConfigSwitchValue(col, scope.row)">
                    <el-tag :type="isConfigSwitchOn(scope.row) ? 'success' : 'info'" size="small" effect="light">
                      {{ isConfigSwitchOn(scope.row) ? '开启' : '关闭' }}
                    </el-tag>
                  </template>
                  <template v-else>
                    <span class="list-cell-text" :title="listCellTitle(col, scope.row)">
                      {{ displayListCellText(col, scope.row) ?? '-' }}
                    </span>
                  </template>
                </template>
              </el-table-column>
              <el-table-column prop="createTime" label="创建时间" min-width="160" />
            </template>
            <el-table-column label="操作" fixed="right" :width="opColumnWidth" class-name="op-col">
              <template #default="scope">
                <div class="op-cell">
                  <el-button type="primary" link size="small" @click="handleEditRow(scope.row)">编辑</el-button>
                  <el-button type="warning" link size="small" @click="handleCopyRow(scope.row)">复制</el-button>
                  <el-button
                    v-if="isAccountForm"
                    type="warning"
                    link
                    size="small"
                    @click="handleResetPasswordRow(scope.row)"
                  >重置密码</el-button>
                  <el-button
                    v-if="props.formCode === 'QrcodeBatch'"
                    type="success"
                    link
                    size="small"
                    @click="handleQrcodeGenerate(scope.row)"
                  >生成二维码</el-button>

                  <el-button
                    v-if="props.formCode === 'LotteryActivity' && Number(scope.row.drawType) === 2 && Number(scope.row.isDrawn) === 0"
                    type="success"
                    link
                    size="small"
                    @click="handleLotteryDraw(scope.row)"
                  >手动开奖</el-button>
                  <el-button
                    v-if="!isAddressForm && showShelfButton(scope.row)"
                    :type="shelfButtonType(scope.row)"
                    link
                    size="small"
                    @click="handleToggleStatusRow(scope.row)"
                  >{{ shelfButtonLabel(scope.row) }}</el-button>
                  <el-button
                    v-if="isOrderForm && [2, 3].includes(Number(scope.row.status))"
                    type="success"
                    link
                    size="small"
                    @click="handleShipRow(scope.row)"
                  >{{ Number(scope.row.status) === 3 ? '继续发货' : '发货' }}</el-button>
                  <el-button
                    v-if="isLotteryOrderForm && [1, 2].includes(Number(scope.row.orderStatus ?? scope.row.order_status))"
                    type="success"
                    link
                    size="small"
                    @click="handleShipRow(scope.row, 'lottery')"
                  >{{ Number(scope.row.orderStatus ?? scope.row.order_status) === 2 ? '继续发货' : '发货' }}</el-button>
                  <el-button type="danger" link size="small" @click="handleRemoveRow(scope.row)">删除</el-button>
                  <el-button v-if="props.formCode === 'Product'" type="info" link size="small" @click="handleViewAudit(scope.row)">审核信息</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </template>
        <template #pager>
          <el-pagination
            background
            layout="prev, pager, next, sizes, total"
            :current-page="page.current"
            :page-size="page.size"
            :page-sizes="[10, 20, 50, 100]"
            :total="page.total"
            @current-change="(c) => changePage(c)"
            @size-change="(s) => changeSize(s)"
          />
        </template>
      </TableListShell>
      <el-dialog title="审核信息" v-model="auditDialogVisible" width="420px" append-to-body>
        <div class="audit-dialog">
          <div class="audit-dialog__row">
            <span class="label">审核编号：</span>
            <span class="value">{{ auditDialogRecord?.code || '-' }}</span>
            <span
              v-if="auditDialogRecord?.code"
              class="copy-link"
              @click="copyAuditCode"
            >复制</span>
          </div>
          <div class="audit-dialog__row">
            <span class="label">审核状态：</span>
            <span class="value">{{ formatAuditStatus(auditDialogRecord?.auditStatus) }}</span>
          </div>
          <div class="audit-dialog__row">
            <span class="label">提交人：</span>
            <span class="value">{{ auditDialogRecord?.submitterName || '-' }}</span>
          </div>
          <div class="audit-dialog__row">
            <span class="label">提交时间：</span>
            <span class="value">{{ formatDateTime(auditDialogRecord?.submitTime) }}</span>
          </div>
          <div class="audit-dialog__row" v-if="auditDialogRecord?.auditorName">
            <span class="label">审核人：</span>
            <span class="value">{{ auditDialogRecord?.auditorName }}</span>
          </div>
          <div class="audit-dialog__row" v-if="auditDialogRecord?.auditTime">
            <span class="label">审核时间：</span>
            <span class="value">{{ formatDateTime(auditDialogRecord?.auditTime) }}</span>
          </div>
          <div class="audit-dialog__row" v-if="auditDialogRecord?.rejectReason">
            <span class="label">驳回原因：</span>
            <span class="value">{{ auditDialogRecord?.rejectReason }}</span>
          </div>
          <div class="audit-dialog__row" v-if="auditDialogRecord?.auditNotes">
            <span class="label">审核备注：</span>
            <span class="value">{{ auditDialogRecord?.auditNotes }}</span>
          </div>
        </div>
        <template #footer>
          <el-button type="primary" @click="auditDialogVisible = false">关闭</el-button>
        </template>
      </el-dialog>

      <el-dialog
        v-if="isOrderForm || isLotteryOrderForm"
        :title="shipForm.orderType === 'lottery' ? '中奖订单发货' : '订单发货'"
        v-model="shipDialogVisible"
        width="620px"
        append-to-body
        destroy-on-close
      >
        <el-form :model="shipForm" label-width="78px">
          <div v-for="(shipment, index) in shipForm.shipments" :key="shipment.localKey" class="shipment-form-item">
            <div class="shipment-form-item__head">
              <span>包裹 {{ index + 1 }}</span>
              <el-button
                v-if="shipForm.shipments.length > 1"
                type="danger"
                link
                size="small"
                @click="removeShipmentRow(index)"
              >删除</el-button>
            </div>
            <el-form-item label="物流公司" required>
              <el-select
                v-model="shipment.expressCode"
                placeholder="请选择物流公司"
                filterable
                style="width: 100%"
                @change="onExpressChange(index, $event)"
              >
                <el-option
                  v-for="item in expressOptions"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="运单号" required>
              <el-input v-model="shipment.expressSn" placeholder="请输入运单号" clearable />
            </el-form-item>
          </div>
          <el-button class="shipment-add-button" plain type="primary" @click="addShipmentRow">+ 添加一个包裹</el-button>
        </el-form>
        <template #footer>
          <el-button @click="shipDialogVisible = false">取消</el-button>
          <el-button type="primary" :loading="shipLoading" @click="submitShip">确认发货</el-button>
        </template>
      </el-dialog>

      <div v-if="mode === 'form'" class="form-panel">
        <div class="form-shell">
          <div class="form-panel__header">
            <div class="back" @click="backToList">
              <el-icon class="back-icon"><arrow-left /></el-icon>
              <span>返回</span>
            </div>
            <div class="title">{{ formTitle }}</div>
          </div>
          <div class="form-body-row">
            <aside v-if="displayGroups.length" class="form-side">
              <div class="form-nav">
                <div
                  v-for="g in displayGroups"
                  :key="g.key"
                  :class="['form-nav__item', { active: g.key === activeGroup }]"
                  @click="scrollToGroup(g.key)"
                >
                  {{ g.name }}
                </div>
              </div>
            </aside>
            <div class="form-body-card" ref="formBodyRef" v-loading="formEditLoading" element-loading-lock="false">
              <el-form ref="formRef" :model="form" :rules="rules" label-position="top">
                <MetaFormRenderer
                  ref="rendererRef"
                  :fields="schema.formFields"
                  v-model="form"
                  :sub-table-loading="specsSubTableLoading"
                />
              </el-form>
            </div>
          </div>
          <div class="form-footer-bar">
            <div class="form-footer__inner">
              <el-button
                v-if="props.formCode === 'Product'"
                type="primary"
                size="small"
                :loading="submitLoading"
                @click="submitForm()"
              >保存</el-button>
              <el-button
                v-if="props.formCode !== 'Product'"
                type="primary"
                size="small"
                :loading="submitLoading"
                @click="submitForm()"
              >保存</el-button>
            </div>
          </div>
        </div>
      </div>
    </PageShell>

    <el-dialog v-if="props.formCode === 'Admin'" v-model="roleDialogVisible" title="角色分配" width="420px" destroy-on-close>
      <el-form label-width="0">
        <el-form-item>
          <el-select
            v-model="roleCheckedIds"
            multiple
            filterable
            clearable
            collapse-tags
            placeholder="请选择角色"
            style="width: 100%"
          >
            <el-option v-for="r in roleOptions" :key="r.id" :label="r.label" :value="r.id" />
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="roleDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="roleSubmitLoading" @click="submitRoleAssign">保存</el-button>
      </template>
    </el-dialog>

    <el-image-viewer
      v-if="imagePreviewVisible"
      :url-list="[imagePreviewUrl]"
      :z-index="4000"
      teleported
      @close="imagePreviewVisible = false"
    />

    <ProductMpPreviewDrawer
      v-if="props.formCode === 'Product'"
      v-model:visible="productMpPreviewVisible"
      :product-id="productMpPreviewId"
    />
  </div>
</template>

<script setup>
import { ref, onMounted, computed, watch, nextTick } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import axios from 'axios'
import { syncProductModules } from '@/api/productModule'
import { ElMessage, ElMessageBox } from 'element-plus'
import { ArrowLeft, ArrowDown, View, DocumentCopy } from '@element-plus/icons-vue'
import PageShell from '@/components/PageShell.vue'
import TableListShell from '@/components/TableListShell.vue'
import ListFilterPanel from '@/components/ListFilterPanel.vue'
import ListFilterToggle from '@/components/ListFilterToggle.vue'
import { useListFilterPanel } from '@/composables/useListFilterPanel'
import { normalizeImgUrl } from '@/utils/mediaUrl'
import { refreshSiteConfig } from '@/utils/siteConfig'
import { isSuperAdmin as checkSuperAdmin } from '@/utils/auth'
import MetaFormRenderer from '@/components/MetaFormRenderer.vue'
import ProductMpPreviewDrawer from '@/components/ProductMpPreviewDrawer.vue'
import { useMetaReference } from '@/composables/useMetaReference'
import {
  buildProductTypeOptionsFromConfigs,
  findProductConfigByType,
  findDefaultProductConfig,
  parseConfigFormJson,
  isConfigFormJsonEmpty,
  resolveProductTypeFromConfig,
  PRODUCT_DEFAULT_TYPE,
} from '@/constants/productConfigType'

const props = defineProps({
  formCode: { type: String, required: true },
  initMode: { type: String, default: 'list' },
  /** 抽奖活动专用：1=抽奖 2=新品体验馆，由路由固定时不再显示页签 */
  lotteryDrawType: { type: Number, default: null },
  /** 可选页面标题，覆盖 API_MAP 默认标题 */
  pageTitle: { type: String, default: '' },
})

const systemTitle = process.env.VUE_APP_TITLE || '应用系统'
const route = useRoute()
const router = useRouter()

const API_MAP = {
  ImageLibrary: {
    title: '素材库',
    listApi: '/api/image-libraries/list',
    submitApi: '/api/image-libraries/submit',
    removeApi: '/api/image-libraries/remove',
    keywordFields: ['fileName', 'tag', 'savePath', 'category'],
    columns: [
      { prop: 'fileName', label: '文件名', minWidth: 160 },
      { prop: 'category', label: '类别', width: 100 },
      { prop: 'fileSize', label: '大小', width: 100 },
      { prop: 'dimensionLabel', label: '尺寸', width: 120 },
      { prop: 'type', label: '类型', minWidth: 120 },
      { prop: 'savePath', label: '路径', minWidth: 220 },
      { prop: 'referenceLabel', label: '是否引用', width: 100 },
      { prop: 'isPrivate', label: '公开性', width: 80 },
      { prop: 'tag', label: '标签', minWidth: 120 },
      { prop: 'createTime', label: '上传时间', width: 160 },
    ],
  },
  User: {
    title: '用户管理',
    listApi: '/api/users',
    submitApi: '/api/users/submit',
    removeApi: '/api/users/remove',
    keywordFields: ['username', 'account', 'phone'],
  },
  Role: {
    title: '角色管理',
    listApi: '/api/roles',
    submitApi: '/api/roles/submit',
    removeApi: '/api/roles/remove',
    keywordFields: ['roleName', 'roleCode'],
  },
  Order: {
    title: '订单管理',
    listApi: '/api/orders/list',
    submitApi: '/api/orders/submit',
    removeApi: '/api/orders/remove',
    keywordFields: ['orderNo', 'userName', 'phone', 'address'],
  },
  Article: {
    title: '文章管理',
    listApi: '/api/articles/list',
    submitApi: '/api/articles/submit',
    removeApi: '/api/articles/remove',
    keywordFields: ['title', 'summary', 'tags'],
    columns: [
      { prop: 'title', label: '标题', minWidth: 180 },
      { prop: 'categoryId', label: '分类', width: 100 },
      { prop: 'status', label: '状态', width: 90 },
      { prop: 'viewCount', label: '浏览量', width: 90 },
      { prop: 'likeCount', label: '点赞', width: 80 },
      { prop: 'publishTime', label: '发布时间', minWidth: 160 },
      { prop: 'createTime', label: '创建时间', minWidth: 160 },
    ],
  },
  Admin: {
    title: '管理员管理',
    listApi: '/api/admins/list',
    submitApi: '/api/admins/submit',
    removeApi: '/api/admins/remove',
    keywordFields: ['userName', 'nickName', 'email', 'mobile'],
  },
  Designer: {
    title: '设计师管理',
    listApi: '/api/designers/list',
    submitApi: '/api/designers/submit',
    removeApi: '/api/designers/remove',
    keywordFields: ['realName', 'styleTags', 'city', 'contactPhone'],
  },
  Config: {
    title: '系统配置',
    listApi: '/api/configs/list',
    submitApi: '/api/configs/submit',
    removeApi: '/api/configs/remove',
    keywordFields: ['configKey', 'configName'],
  },
  HomeConfig: {
    title: '首页配置',
    listApi: '/api/home-configs/list',
    submitApi: '/api/home-configs/submit',
    removeApi: '/api/home-configs/remove',
    keywordFields: ['name', 'notice'],
  },
  HomeBanner: {
    title: '首页轮播',
    listApi: '/api/home-banners/list',
    submitApi: '/api/home-banners/submit',
    removeApi: '/api/home-banners/remove',
    keywordFields: ['title', 'description'],
  },
  Popup: {
    title: '弹窗管理',
    listApi: '/api/popups/list',
    submitApi: '/api/popups/submit',
    removeApi: '/api/popups/remove',
    keywordFields: ['name', 'content'],
  },
  Coupon: {
    title: '优惠券',
    listApi: '/api/coupons/list',
    submitApi: '/api/coupons/submit',
    removeApi: '/api/coupons/remove',
    keywordFields: ['name', 'description'],
  },
  CouponBasic: {
    title: '优惠券基础表',
    listApi: '/api/coupon-basics/list',
    submitApi: '/api/coupon-basics/submit',
    removeApi: '/api/coupon-basics/remove',
    keywordFields: ['name', 'subtitle'],
  },
  Product: {
    title: '商品管理',
    listApi: '/api/products/list',
    submitApi: '/api/products/submit',
    removeApi: '/api/products/remove',
    keywordFields: ['title', 'subtitle'],
  },
  Label: {
    title: '标签管理',
    listApi: '/api/labels/list',
    submitApi: '/api/labels/submit',
    removeApi: '/api/labels/remove',
    keywordFields: ['label', 'subtitle', 'description'],
    columns: [
      { prop: 'label', label: '标签名称', minWidth: 140 },
      { prop: 'subtitle', label: '副标题', minWidth: 160 },
      { prop: 'type', label: '标签类型', minWidth: 100 },
      { prop: 'showInFilterLabel', label: '筛选显示', minWidth: 100 },
      { prop: 'count', label: '使用次数', minWidth: 100 },
      { prop: 'targetType', label: '目标类型', minWidth: 100 },
      { prop: 'targetId', label: '目标ID', minWidth: 100 },
    ],
  },
  ProductModel: {
    title: '模型管理',
    listApi: '/api/product-models/list',
    submitApi: '/api/product-models/submit',
    removeApi: '/api/product-models/remove',
    keywordFields: ['name', 'description'],
  },
  PointsProduct: {
    title: '积分商品管理',
    listApi: '/api/points-products/list',
    submitApi: '/api/points-products/submit',
    removeApi: '/api/points-products/remove',
    keywordFields: ['title', 'description'],
  },
  MemberPrivilege: {
    title: '会员权益管理',
    listApi: '/api/member-privileges/list',
    submitApi: '/api/member-privileges/submit',
    removeApi: '/api/member-privileges/remove',
    keywordFields: ['privilegeKey', 'name', 'description'],
  },
  ExpressBusinessType: {
    title: '快递业务类型管理',
    listApi: '/api/express-business-types/list',
    submitApi: '/api/express-business-types/submit',
    removeApi: '/api/express-business-types/remove',
    keywordFields: ['serviceType', 'serviceName'],
    columns: [
      { prop: 'kuaidiId', label: '快递公司ID', minWidth: 120 },
      { prop: 'serviceType', label: '业务类型编码', minWidth: 140 },
      { prop: 'serviceName', label: '业务类型名称', minWidth: 140 },
      { prop: 'sortOrder', label: '排序', minWidth: 80 },
      { prop: 'status', label: '状态', minWidth: 80 },
    ],
    formFields: [
      { prop: 'kuaidiId', label: '快递公司ID', type: 'number', required: true, width: '50%' },
      { prop: 'serviceType', label: '业务类型编码', type: 'input', required: true, width: '50%' },
      { prop: 'serviceName', label: '业务类型名称', type: 'input', required: true, width: '50%' },
      { prop: 'sortOrder', label: '排序', type: 'number', required: false, width: '50%' },
      { prop: 'status', label: '状态', type: 'number', required: false, width: '50%' },
    ],
  },
  DeliveryExpress: {
    title: '快递公司管理',
    listApi: '/api/delivery-expresses/list',
    submitApi: '/api/delivery-expresses/submit',
    removeApi: '/api/delivery-expresses/remove',
    keywordFields: ['name', 'code'],
    columns: [
      { prop: 'name', label: '公司名称', minWidth: 140 },
      { prop: 'code', label: '编码', minWidth: 120 },
      { prop: 'image', label: '图标', minWidth: 100 },
      { prop: 'sort', label: '排序', minWidth: 80 },
      { prop: 'type', label: '数据类型', minWidth: 120 },
    ],
    formFields: [
      { prop: 'name', label: '公司名称', type: 'input', required: true, width: '50%' },
      { prop: 'code', label: '编码', type: 'input', required: true, width: '50%' },
      { prop: 'type', label: '数据类型', type: 'input', required: false, width: '50%', placeholder: '如：kdniao' },
      { prop: 'sort', label: '排序', type: 'number', required: false, width: '50%' },
      { prop: 'image', label: '图标', type: 'upload', component: 'upload', required: false, width: '100%', multiple: false },
    ],
  },
  Level: {
    title: '等级管理',
    listApi: '/api/levels/list',
    submitApi: '/api/levels/submit',
    removeApi: '/api/levels/remove',
    keywordFields: ['name', 'level'],
    idField: 'id',
    columns: [
      { prop: 'name', label: '等级名称' },
      { prop: 'level', label: '等级值', minWidth: 120 },
      { prop: 'icon', label: '等级图标', minWidth: 160 },
      { prop: 'minExp', label: '最低经验值', minWidth: 140 },
      { prop: 'discount', label: '积分倍率', minWidth: 140 },
      { prop: 'description', label: '描述', minWidth: 200 },
    ],
    formFields: [
      { prop: 'name', label: '等级名称', type: 'input', required: true, width: '50%' },
      { prop: 'level', label: '等级值', type: 'number', required: true, width: '50%' },
      { prop: 'icon', label: '等级图标', type: 'upload', component: 'upload', required: false, width: '50%', multiple: false },
      { prop: 'minExp', label: '最低经验值', type: 'number', required: false, width: '50%' },
      { prop: 'discount', label: '积分倍率', type: 'number', required: false, width: '50%' },
      { prop: 'description', label: '描述', type: 'textarea', required: false, width: '100%' },
    ],
  },
  DesignerLevel: {
    title: '设计师等级管理',
    listApi: '/api/designer-levels/list',
    submitApi: '/api/designer-levels/submit',
    removeApi: '/api/designer-levels/remove',
    keywordFields: ['name', 'level'],
    idField: 'id',
    columns: [
      { prop: 'name', label: '等级名称' },
      { prop: 'level', label: '等级值', minWidth: 120 },
      { prop: 'icon', label: '等级图标', minWidth: 160 },
      { prop: 'minExp', label: '最低经验值', minWidth: 140 },
      { prop: 'discount', label: '积分倍率', minWidth: 140 },
      { prop: 'description', label: '描述', minWidth: 200 },
    ],
    formFields: [
      { prop: 'name', label: '等级名称', type: 'input', required: true, width: '50%' },
      { prop: 'level', label: '等级值', type: 'number', required: true, width: '50%' },
      { prop: 'icon', label: '等级图标', type: 'upload', component: 'upload', required: false, width: '50%', multiple: false },
      { prop: 'minExp', label: '最低经验值', type: 'number', required: false, width: '50%' },
      { prop: 'discount', label: '积分倍率', type: 'number', required: false, width: '50%' },
      { prop: 'description', label: '描述', type: 'textarea', required: false, width: '100%' },
    ],
  },
  DesignerAddress: {
    title: '地址管理',
    listApi: '/api/designer-addresses/list',
    submitApi: '/api/designer-addresses/submit',
    removeApi: '/api/designer-addresses/remove',
    keywordFields: ['userName', 'phone', 'address', 'city'],
    columns: [
      { prop: 'userName', label: '姓名', minWidth: 120 },
      { prop: 'phone', label: '电话', minWidth: 140 },
      { prop: 'province', label: '所在省', voProp: 'provinceName', minWidth: 120 },
      { prop: 'city', label: '所在市', voProp: 'cityName', minWidth: 120 },
      { prop: 'district', label: '所在区', voProp: 'districtName', minWidth: 120 },
      { prop: 'address', label: '详细地址', minWidth: 200 },
    ],
  },
  Address: {
    title: '收货地址管理',
    listApi: '/api/address/list',
    submitApi: '/api/address/submit',
    removeApi: '/api/address/remove',
    keywordFields: ['userName', 'phone', 'address', 'city'],
    columns: [
      { prop: 'userName', label: '姓名', minWidth: 120 },
      { prop: 'phone', label: '电话', minWidth: 140 },
      { prop: 'province', label: '所在省', voProp: 'provinceName', minWidth: 120 },
      { prop: 'city', label: '所在市', voProp: 'cityName', minWidth: 120 },
      { prop: 'district', label: '所在区', voProp: 'districtName', minWidth: 120 },
      { prop: 'address', label: '详细地址', minWidth: 200 },
    ],
  },
  LotteryActivity: {
    title: '抽奖活动',
    listApi: '/api/lottery-activities/list',
    submitApi: '/api/lottery-activities/submit',
    removeApi: '/api/lottery-activities/remove',
    keywordFields: ['name', 'description', 'detail'],
    columns: [
      { prop: 'name', label: '活动名称', minWidth: 160 },
      { prop: 'startTime', label: '开始时间', minWidth: 160 },
      { prop: 'endTime', label: '结束时间', minWidth: 160 },
      { prop: 'participantCount', label: '参与人数', width: 100 },
      { prop: 'auditStatus', label: '审核状态', width: 100 },
      { prop: 'isDrawn', label: '已开奖', width: 90 },
      { prop: 'createTime', label: '创建时间', minWidth: 160 },
    ],
  },
  LotteryPrize: {
    title: '奖品设置',
    listApi: '/api/lottery-prizes/list',
    submitApi: '/api/lottery-prizes/submit',
    removeApi: '/api/lottery-prizes/remove',
    keywordFields: ['name', 'remark'],
    columns: [
      { prop: 'name', label: '奖品名称', minWidth: 160 },
      { prop: 'type', label: '类型', width: 90 },
      { prop: 'inventory', label: '库存', width: 90 },
      { prop: 'sort', label: '排序', width: 80 },
      { prop: 'status', label: '状态', width: 80 },
      { prop: 'createTime', label: '创建时间', minWidth: 160 },
    ],
  },
  LotteryParticipant: {
    title: '参与记录',
    listApi: '/api/lottery-participants/list',
    submitApi: '/api/lottery-participants/submit',
    removeApi: '/api/lottery-participants/remove',
    keywordFields: ['prizeName', 'verifyCode', 'ext'],
    columns: [
      { prop: 'lotteryId', label: '活动ID', width: 100 },
      { prop: 'userId', label: '用户ID', width: 100 },
      { prop: 'verifyCode', label: '核销码', minWidth: 140 },
      { prop: 'isVerified', label: '已核销', width: 90 },
      { prop: 'prizeName', label: '奖品', minWidth: 140 },
      { prop: 'joinTime', label: '参与时间', minWidth: 160 },
    ],
  },
  LotteryDrawRecord: {
    title: '抽奖记录',
    listApi: '/api/lottery-draw-records/list',
    submitApi: '/api/lottery-draw-records/submit',
    removeApi: '/api/lottery-draw-records/remove',
    keywordFields: ['prizeName', 'activityPrizeName'],
    columns: [
      { prop: 'activityId', label: '活动ID', width: 100 },
      { prop: 'userId', label: '用户ID', width: 100 },
      { prop: 'prizeName', label: '奖品名称', minWidth: 140 },
      { prop: 'isWin', label: '中奖', width: 80 },
      { prop: 'isClaimed', label: '已领取', width: 90 },
      { prop: 'round', label: '轮次', width: 80 },
      { prop: 'createTime', label: '抽奖时间', minWidth: 160 },
    ],
  },
  LotteryOrder: {
    title: '中奖订单',
    listApi: '/api/lottery-orders/list',
    submitApi: '/api/lottery-orders/submit',
    removeApi: '/api/lottery-orders/remove',
    keywordFields: ['orderNo', 'prizeName', 'activityName', 'consignee', 'mobile'],
    columns: [
      { prop: 'orderNo', label: '订单号', minWidth: 160 },
      { prop: 'activityName', label: '活动名称', minWidth: 140 },
      { prop: 'prizeName', label: '奖品名称', minWidth: 140 },
      { prop: 'consignee', label: '收货人', width: 100 },
      { prop: 'mobile', label: '电话', width: 120 },
      { prop: 'status', label: '状态', width: 90 },
      { prop: 'expressNo', label: '快递单号', minWidth: 140 },
      { prop: 'createTime', label: '创建时间', minWidth: 160 },
    ],
  },
  Card: {
    title: '卡片管理',
    listApi: '/api/cards/list',
    submitApi: '/api/cards/submit',
    removeApi: '/api/cards/remove',
    keywordFields: ['name', 'description', 'spec'],
  },
  QrcodeBatch: {
    title: '二维码批次管理',
    listApi: '/api/qrcode-batches/list',
    submitApi: '/api/qrcode-batches/submit',
    removeApi: '/api/qrcode-batches/remove',
    keywordFields: ['batchName', 'targetName', 'type'],
  },
  QrcodeDetail: {
    title: '二维码详情',
    listApi: '/api/qrcode-details/list',
    submitApi: '/api/qrcode-details/submit',
    removeApi: '/api/qrcode-details/remove',
    keywordFields: ['code'],
  },
}

const schema = ref({
  title: '',
  listApi: '',
  submitApi: '',
  removeApi: '',
  idField: 'id',
  keywordFields: [],
  columns: [],
  formFields: [],
})


const { preloadForFormAndList, isReferenceColumn, resolveRefLabel } = useMetaReference()

const displayGroups = computed(() => {
  const list = Array.isArray(schema.value.formFields) ? schema.value.formFields : []
  const groups = {}
  list.forEach((f) => {
    if (toBool(f.hidden)) return
    
    // 如果是商品模块且有选择类型，则过滤字段
    if (props.formCode === 'Product' && currentProductType.value !== null && currentProductType.value !== undefined) {
      // proType 为 null/undefined 表示通用字段，显示给所有类型
      // proType 有值时，只显示给匹配的类型
      if (f.proType !== null && f.proType !== undefined && String(f.proType) !== String(currentProductType.value)) {
        return
      }
    }

    if (props.formCode === 'Product' && String(currentProductType.value) === '2' && f.isSubTable) {
      return
    }

    const pk = schema.value.idField || 'id'
    if (f.prop === pk && mode.value === 'form' && !form.value?.[pk]) {
      return
    }
    
    const name = f.category || '基础设置'
    const key = name
    const order = Number.isFinite(f.categoryOrder) ? f.categoryOrder : 0
    if (!groups[key]) groups[key] = { name, key, order, fields: [] }
    groups[key].fields.push(f)
  })
  return Object.values(groups)
    .sort((a, b) => a.order - b.order)
    .map((g) => ({
      ...g,
      fields: g.fields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0)),
    }))
})

const activeGroup = ref('')
const formBodyRef = ref(null)
const rendererRef = ref(null)

const breadcrumbBase = computed(() => [
  { label: '导航', path: '/admin/menu' },
  { label: schema.value.title || props.formCode },
])

const breadcrumbs = computed(() => breadcrumbBase.value)

const resolveInitMode = () => (props.initMode === 'form' ? 'form' : 'list')
const mode = ref(resolveInitMode()) // list | form
const loading = ref(false)
const formEditLoading = ref(false)
const specsSubTableLoading = ref(false)
const submitLoading = ref(false)
const productModuleSyncLoading = ref(false)

watch(
  displayGroups,
  (list) => {
    if (list?.length) {
      activeGroup.value = list[0].key
    }
  },
  { immediate: true }
)

const scrollToGroup = (key) => {
  activeGroup.value = key
  const container = formBodyRef.value
  rendererRef.value?.scrollToSection?.(key, container)
}
const roleDialogVisible = ref(false)
const roleSubmitLoading = ref(false)
const roleOptions = ref([])
const roleCheckedIds = ref([])
const tableData = ref([])
const keyword = ref('')
const productNameFilter = ref('')
const productCodeFilter = ref('')
const productTypeFilter = ref(null)
const designerQueryFilter = ref(null)
const draftKeyword = ref('')
const draftProductCode = ref('')
const draftProductName = ref('')
const draftProductType = ref(null)
const draftDesignerQuery = ref(null)
const draftSelectedConfigId = ref(null)
const productDesignerOptions = ref([])
const productDesignerOptionsLoading = ref(false)
const productActiveTab = ref('review')
const lotteryActiveTab = ref('lottery')
const lotteryStatusTab = ref('all')
const orderActiveTab = ref('all')
const lotteryOrderTab = ref('all')
const commonStatusTab = ref('all')
const lotteryTabInitialized = ref(false)
const productTabStatusMap = {
  draft: 0,
  review: 1,
  selling: 2,
  rejected: 3,
  archived: 4,
}
const orderTabStatusMap = {
  all: null,
  pendingPay: 1,
  pendingShip: 2,
  pendingReceive: 3,
  signed: 4,
}
const lotteryOrderTabMap = {
  all: null,
  pendingShip: 1,
  shipped: 2,
}
const commonStatusTabMap = {
  all: null,
  published: 1,
  draft: 0,
}
const page = ref({ current: 1, size: 10, total: 0 })
const selectedIds = ref([])
const current = ref(null)
const dictCache = ref({})

const formTitle = ref('')
const formRef = ref()
const form = ref({})
const productTypeOptions = ref([])
const currentProductType = ref(null)
const DEFAULT_CONFIG_KEY = 'metaFormDefaultConfigMap'
const formConfigs = ref([])
const selectedConfigId = ref(null)
const isOrderForm = computed(() => props.formCode === 'Order')
const isLotteryOrderForm = computed(() => props.formCode === 'LotteryOrder')
const isAccountForm = computed(() => props.formCode === 'Admin' || props.formCode === 'User')
const isTypeBoundForm = computed(() => props.formCode === 'Product')
const showProductDesignerQuery = computed(() => props.formCode === 'Product' && checkSuperAdmin())
const isLotteryActivityForm = computed(() => props.formCode === 'LotteryActivity')
const isLotteryDrawTypeFixed = computed(() => props.lotteryDrawType === 1 || props.lotteryDrawType === 2)
const showLotteryTabs = computed(() => isLotteryActivityForm.value && !isLotteryDrawTypeFixed.value)
const showLotteryStatusTabs = computed(() => isLotteryActivityForm.value && isLotteryDrawTypeFixed.value)

const lotteryTimelyStatusTabs = [
  { label: '全部', name: 'all' },
  { label: '限定抽奖', name: 'limited' },
  { label: '常规抽奖', name: 'normal' },
  { label: '待发布', name: 'draft' },
  { label: '历史抽奖', name: 'history' },
]

const lotteryScheduledStatusTabs = [
  { label: '全部', name: 'all' },
  { label: '待发布', name: 'draft' },
  { label: '进行中', name: 'ongoing' },
  { label: '待开奖', name: 'pending' },
  { label: '已开奖', name: 'drawn' },
  { label: '已结束', name: 'ended' },
]

const isAddressForm = computed(() => props.formCode === 'DesignerAddress' || props.formCode === 'Address')
const isDesignerForm = computed(() => props.formCode === 'Designer')
const isConfigForm = computed(() => props.formCode === 'Config')
const isCardForm = computed(() => props.formCode === 'Card')
const isQrcodeForm = computed(() => props.formCode === 'QrcodeBatch' || props.formCode === 'QrcodeDetail')
const showOrderTabs = computed(() => isOrderForm.value)
const showLotteryOrderTabs = computed(() => isLotteryOrderForm.value)
const showCommonStatusTabs = computed(() => !isTypeBoundForm.value && !isLotteryActivityForm.value && !isLotteryOrderForm.value && !isAddressForm.value && !isDesignerForm.value && !isConfigForm.value && !isCardForm.value && !isQrcodeForm.value && !isOrderForm.value && !isAccountForm.value)
const showConfigSelect = computed(() => !isTypeBoundForm.value && !isLotteryActivityForm.value && formConfigs.value.length)

const opColumnWidth = computed(() => (isOrderForm.value || isLotteryOrderForm.value) ? 220 : 148)

const lotteryDrawTypeMap = {
  lottery: 1,
  experience: 2,
}

const lotteryTabByDrawType = (drawType) => (Number(drawType) === 2 ? 'experience' : 'lottery')

const currentLotteryDrawType = computed(() => {
  if (isLotteryDrawTypeFixed.value) return props.lotteryDrawType
  return lotteryDrawTypeMap[lotteryActiveTab.value] ?? 1
})

const lotteryStatusTabOptions = computed(() => (
  Number(currentLotteryDrawType.value) === 2 ? lotteryScheduledStatusTabs : lotteryTimelyStatusTabs
))

const syncLotteryStatusTab = () => {
  const names = lotteryStatusTabOptions.value.map((t) => t.name)
  if (!names.includes(lotteryStatusTab.value)) {
    lotteryStatusTab.value = names[0] || 'all'
  }
}

watch(currentLotteryDrawType, () => {
  lotteryStatusTab.value = 'all'
})

watch(lotteryStatusTabOptions, syncLotteryStatusTab, { flush: 'sync' })

const currentLotteryTabName = computed(() => lotteryTabByDrawType(currentLotteryDrawType.value))

const matchLotteryConfig = (configs, tabName) => {
  const list = configs || []
  const drawType = lotteryDrawTypeMap[tabName] ?? 1
  const byType = list.find((cfg) => Number(cfg.type) === drawType)
  if (byType) return byType
  if (tabName === 'experience') {
    return list.find((cfg) => cfg.name && cfg.name.includes('新品')) || list[1] || list[0]
  }
  return list.find((cfg) => cfg.name && cfg.name.includes('抽奖') && !cfg.name.includes('新品')) || list[0]
}

const syncLotteryTabFromConfig = (cfg) => {
  if (!cfg) return
  if (Number(cfg.type) === 2 || (cfg.name && cfg.name.includes('新品'))) {
    lotteryActiveTab.value = 'experience'
  } else {
    lotteryActiveTab.value = 'lottery'
  }
  selectedConfigId.value = cfg.id
}

const resolveLotteryActivityConfig = () => {
  const configs = formConfigs.value || []
  return matchLotteryConfig(configs, currentLotteryTabName.value)
}

const loadDefaultConfigMap = () => {
  try {
    const raw = localStorage.getItem(DEFAULT_CONFIG_KEY)
    return raw ? JSON.parse(raw) : {}
  } catch (e) {
    console.warn('读取默认配置映射失败', e)
    return {}
  }
}

const getDefaultConfigId = (schemaCode) => {
  if (!schemaCode) return null
  const map = loadDefaultConfigMap()
  return map[schemaCode]
}

const saveDefaultConfigId = (schemaCode, configId) => {
  if (!schemaCode || configId === undefined || configId === null) return
  try {
    const map = loadDefaultConfigMap()
    map[schemaCode] = configId
    localStorage.setItem(DEFAULT_CONFIG_KEY, JSON.stringify(map))
  } catch (e) {
    console.warn('保存默认配置失败', e)
  }
}

const ensureFormConfigs = async () => {
  if (!props.formCode) return []
  try {
    const res = await axios.get(`/api/meta-form-configs/by-schema/${props.formCode}`)
    let list = res.data?.data || []
    if (!list.length) {
      await axios.post('/api/meta-form-configs/submit', {
        schemaCode: props.formCode,
        name: '标品',
        type: PRODUCT_DEFAULT_TYPE,
        status: 1,
      })
      const refresh = await axios.get(`/api/meta-form-configs/by-schema/${props.formCode}`)
      list = refresh.data?.data || []
    }
    formConfigs.value = list
    if (isLotteryActivityForm.value && list.length && !lotteryTabInitialized.value) {
      if (isLotteryDrawTypeFixed.value) {
        lotteryActiveTab.value = lotteryTabByDrawType(props.lotteryDrawType)
        const cfg = matchLotteryConfig(list, lotteryActiveTab.value)
        if (cfg?.id) selectedConfigId.value = cfg.id
      } else {
        const persisted = getDefaultConfigId(props.formCode)
        const defaultCfg = list.find((cfg) => String(cfg.id) === String(persisted)) || list[0]
        syncLotteryTabFromConfig(defaultCfg)
      }
      lotteryTabInitialized.value = true
    } else if (!isTypeBoundForm.value && !isLotteryActivityForm.value && list.length) {
      const persisted = getDefaultConfigId(props.formCode)
      const match = list.find((cfg) => String(cfg.id) === String(persisted)) || list[0]
      selectedConfigId.value = match?.id ?? null
    }
    return list
  } catch (e) {
    console.warn('加载表单配置列表失败', e)
    return []
  }
}

const resolveGenericConfig = async () => {
  if (!props.formCode) return null
  if (!formConfigs.value.length) {
    await ensureFormConfigs()
  }
  const config = formConfigs.value.find((cfg) => String(cfg.id) === String(selectedConfigId.value)) || formConfigs.value[0] || null
  if (config && !isTypeBoundForm.value && !isLotteryActivityForm.value) {
    saveDefaultConfigId(props.formCode, config.id)
    selectedConfigId.value = config.id
  }
  return config
}

const handleGenericConfigSelect = (value) => {
  selectedConfigId.value = value
}
const loadDictOptions = async (code) => {
  if (!code) return []
  if (dictCache.value[code]) return dictCache.value[code]
  try {
    const res = await axios.get('/api/dictionaries/list', { params: { code, size: 2000 } })
    const raw = res.data && (res.data.data ?? res.data)
    const list = raw?.records || raw || []
    const opts = list
      .filter((item) => {
        const key = item.dictKey ?? item.dict_key ?? item.key
        if (key === undefined || key === null) return true
        const parsed = Number(key)
        return Number.isNaN(parsed) ? true : parsed >= 1
      })
      .map((item) => ({
        label: item.name || item.dictLabel || item.label || item.dictName || item.value,
        value: item.dictKey ?? item.dict_key ?? item.dictValue ?? item.value ?? item.key,
      }))
      .filter((item) => item.value !== undefined && item.value !== null && String(item.value).trim() !== '')
    dictCache.value[code] = opts
    return opts
  } catch (err) {
    console.warn('加载字典失败', code, err)
    dictCache.value[code] = []
    return []
  }
}

const productDesignerDisplayName = (item) => {
  if (!item) return '未命名设计师'
  const names = [
    item.artistName,
    item.realName,
    item.studioName,
    item.createUserName,
    item.name,
  ].filter((name, index, arr) => name && arr.indexOf(name) === index)
  return names.join(' / ') || `设计师${item.id || ''}`
}

const loadProductDesignerOptions = async (keyword = '') => {
  if (!showProductDesignerQuery.value) return
  productDesignerOptionsLoading.value = true
  try {
    const res = await axios.get('/api/designers/list', {
      params: {
        current: 1,
        size: 500,
        keyword: keyword || undefined,
      },
    })
    const data = res?.data?.data || {}
    const records = data.records || []
    const selectedId = draftDesignerQuery.value || designerQueryFilter.value
    const selectedOption = selectedId
      ? productDesignerOptions.value.find((item) => String(item.id) === String(selectedId))
      : null
    if (selectedOption && !records.some((item) => String(item.id) === String(selectedId))) {
      productDesignerOptions.value = [selectedOption, ...records]
    } else {
      productDesignerOptions.value = records
    }
  } catch (err) {
    console.warn('加载商品设计师下拉失败', err)
    productDesignerOptions.value = []
  } finally {
    productDesignerOptionsLoading.value = false
  }
}

const searchProductDesigners = (keyword) => {
  loadProductDesignerOptions(keyword)
}

const handleProductDesignerVisibleChange = (visible) => {
  if (visible) {
    loadProductDesignerOptions()
  }
}

const rules = computed(() => {
  const r = {}
  const pk = schema.value.idField || 'id'
  ;(schema.value.formFields || []).forEach((f) => {
    if (f.prop === pk && !form.value?.[pk]) return
    if (f.required) {
      r[f.prop] = [{ required: true, message: `请输入${f.label}`, trigger: 'blur' }]
    }
  })
  return r
})

const LIST_CELL_DEFAULT_CHARS = 20
const LIST_CELL_MAX_CHARS = 40
const LIST_COLUMN_MIN_WIDTH = 88
const LIST_COLUMN_MAX_INITIAL_WIDTH = 344
const LIST_COLUMN_HORIZONTAL_PADDING = 36
const LIST_COLUMN_CJK_CHAR_WIDTH = 14
const listColumnWidths = ref({})
const resizedListColumns = ref({})

const getEmptyForm = () => {
  const obj = {}
  ;(schema.value.formFields || []).forEach((f) => {
    if (f.isSubTable) {
      // 子表字段初始化为空数组
      if (f.parentField && !obj[f.parentField]) {
        obj[f.parentField] = []
      }
    } else if (f.multiple || f.prop === 'contentImages') {
      obj[f.prop] = []
    } else {
      obj[f.prop] = ''
    }
  })
  obj[schema.value.idField || 'id'] = null
  return obj
}

const stripHtmlToPlainText = (val) => {
  if (val == null || val === '') return ''
  const str = String(val)
  if (!/[<>]/.test(str)) return str
  return str
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/p>/gi, '\n')
    .replace(/<[^>]+>/g, '')
    .replace(/\n{2,}/g, '\n')
    .trim()
}

const extractImagesFromHtml = (html) => {
  if (!html || !/[<]img/i.test(String(html))) return []
  const urls = []
  const re = /<img[^>]+src=["']([^"']+)["']/gi
  let match = re.exec(String(html))
  while (match) {
    if (match[1]) urls.push(match[1])
    match = re.exec(String(html))
  }
  return urls
}

const toRelativeUploadPath = (url) => {
  if (!url) return ''
  const str = String(url)
  try {
    const u = new URL(str, window.location.origin)
    return u.pathname + u.search
  } catch {
    return str
  }
}

const applyArticleFormOverrides = (next) => {
  if (props.formCode !== 'Article') return
  let fields = [...(next.formFields || [])]
  fields = fields.map((f) => {
    if (f.prop === 'content') {
      const placeholder = f.placeholder || '正文纯文本，支持换行（小红书风格）'
      return {
        ...f,
        type: 'textarea',
        component: 'el-input',
        label: f.label || '文章内容',
        placeholder,
        attrs: { type: 'textarea', rows: 10, placeholder },
        listHidden: true,
      }
    }
    if (f.prop === 'contentImages') {
      return {
        ...f,
        type: 'image',
        multiple: true,
        label: f.label || '正文图片',
        placeholder: f.placeholder || '可上传多张，与正文分开展示',
        listHidden: true,
      }
    }
    return f
  })
  if (!fields.some((f) => f.prop === 'contentImages')) {
    const contentIdx = fields.findIndex((f) => f.prop === 'content')
    const baseCategory = contentIdx >= 0 ? fields[contentIdx].category : '基础设置'
    const baseOrder = contentIdx >= 0 ? (fields[contentIdx].order ?? 0) : 50
    fields.splice(contentIdx >= 0 ? contentIdx + 1 : fields.length, 0, {
      prop: 'contentImages',
      label: '正文图片',
      placeholder: '可上传多张，与正文分开展示',
      type: 'image',
      multiple: true,
      component: 'el-upload',
      width: '100%',
      required: false,
      hidden: false,
      listHidden: true,
      category: baseCategory,
      categoryOrder: contentIdx >= 0 ? fields[contentIdx].categoryOrder : 0,
      order: baseOrder + 0.5,
    })
  }
  next.formFields = fields
}

const applyProductLabelsOverride = (next) => {
  if (props.formCode !== 'Product') return
  next.formFields = (next.formFields || []).map((f) => {
    const prop = String(f?.prop || f?.field || '').trim()
    if (prop !== 'labels') return f
    const placeholder = f.placeholder || '请选择商品标签'
    return {
      ...f,
      prop: f.prop || 'labels',
      label: f.label || '商品标签',
      placeholder,
      type: 'category-tree',
      component: 'category-tree',
      attrs: { ...(f.attrs || {}), placeholder },
      apiUrl: '/api/labels/list',
      pageSize: f.pageSize || f.size || 999,
      multiple: true,
    }
  })
}

const applyHomeConfigFormOverrides = (next) => {
  if (props.formCode !== 'HomeConfig') return
  next.formFields = (next.formFields || []).map((f) => {
    const prop = String(f?.prop || f?.field || '').trim()
    if (prop !== 'hotProducts' && prop !== 'newProducts') return f
    const isHot = prop === 'hotProducts'
    return {
      ...f,
      label: f.label || (isHot ? '热门商品' : '新品速递'),
      placeholder: f.placeholder || (isHot ? '请选择热门商品' : '请选择新品速递商品'),
      type: 'select',
      component: 'el-select',
      apiUrl: '/api/products/list',
      pageSize: f.pageSize || f.size || 999,
      multiple: true,
      optionValuePrefix: 'p_',
    }
  })
}

const mapType = (t) => {
  const tp = (t || '').toLowerCase()
  if (['richtext', 'rich-text', 'rich_text', 'editor', '富文本'].includes(tp)) return 'richtext'
  if (['int', 'long', 'number', 'numeric'].includes(tp)) return 'number'
  if (['text', 'textarea', 'remark'].includes(tp)) return 'textarea'
  if (['select', 'dict'].includes(tp)) return 'select'
  if (['tree', 'tree-select', 'treeselect', 'category-tree', 'category_tree', 'cascader'].includes(tp)) return 'category-tree'
  if (['upload', '上传', 'file', '附件'].includes(tp)) return 'upload'
  if (['image', 'img', '图片'].includes(tp)) return 'image'
  if (['date', '日期'].includes(tp)) return 'date'
  if (['datetime', 'timestamp', '日期时间', '时间日期'].includes(tp)) return 'datetime'
  return 'input'
}

const isDateTimeFieldType = (type) => {
  const tp = String(type || '').toLowerCase()
  return ['datetime', 'timestamp', '日期时间', '时间日期'].includes(tp)
}

const isDateFieldType = (type) => {
  const tp = String(type || '').toLowerCase()
  return tp === 'date' || tp === '日期'
}

const KNOWN_DATETIME_PROPS = new Set([
  'starttime', 'endtime', 'drawtime', 'prizeexpiretime', 'deletedat',
  'createtime', 'updatetime', 'jointime', 'pickupstarttime', 'publishtime',
])

const normalizeDateTimeForSubmit = (value) => {
  if (value === null || value === undefined || value === '') return null
  let s = String(value).trim()
  if (!s) return null
  if (/^\d{4}-\d{2}-\d{2}T/.test(s)) {
    s = s.replace('T', ' ').replace(/\.\d+Z?$/, '').replace(/Z$/, '')
  }
  if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/.test(s)) {
    s = `${s}:00`
  }
  return s
}

const normalizeDateForSubmit = (value) => {
  if (value === null || value === undefined || value === '') return null
  const s = String(value).trim()
  if (!s) return null
  return s.slice(0, 10)
}

const isImageColumn = (col) => {
  if (!col) return false
  const prop = String(col.prop || '').toLowerCase()
  if (prop.includes('avatar') || prop.includes('icon') || prop.includes('img') || prop.includes('image')) return true
  const tp = String(col.type || '').toLowerCase()
  return tp === 'image' || tp === 'img' || tp === 'avatar'
}

const LONG_TEXT_COLUMN_TYPES = new Set(['richtext', 'rich-text', 'rich_text', 'editor', 'html', 'textarea', 'markdown', 'md', '富文本'])
const isLongTextColumn = (col) => {
  if (!col) return false
  const prop = String(col.prop || '').toLowerCase()
  if (['content', 'body', 'description', 'detail', 'htmlcontent', 'html_content'].includes(prop)) return true
  if (prop.includes('content') || prop.endsWith('html')) return true
  const tp = String(col.type || '').toLowerCase()
  return LONG_TEXT_COLUMN_TYPES.has(tp)
}

const stripHtml = (val) => {
  if (val == null || val === '') return ''
  const str = String(val)
  if (!/[<>]/.test(str)) return str
  return str.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim()
}

const formatListCellText = (col, row) => {
  const val = columnValue(col, row)
  if (val == null || val === '') return undefined
  return isLongTextColumn(col) ? stripHtml(val) : val
}

const isCompactListColumn = (col) => {
  if (!col) return false
  if (isImageColumn(col)) return true
  const prop = String(col.prop || '').toLowerCase()
  return ['status', 'sort', 'weigh', 'level', 'quantity', 'stock', 'type'].includes(prop)
}

const listTextCharacters = (value) => Array.from(value == null ? '' : String(value))

const truncateListText = (value, maxChars) => {
  const characters = listTextCharacters(value)
  if (characters.length <= maxChars) return characters.join('')
  return `${characters.slice(0, maxChars).join('')}...`
}

const estimateListTextWidth = (value) => {
  const width = listTextCharacters(value).reduce((sum, char) => {
    const codePoint = char.codePointAt(0) || 0
    if (codePoint > 255) return sum + LIST_COLUMN_CJK_CHAR_WIDTH
    if (/\s/.test(char)) return sum + 4
    if (/[A-Z]/.test(char)) return sum + 8.5
    if (/[a-z0-9]/.test(char)) return sum + 7.5
    return sum + 8
  }, 0)
  return Math.ceil(width + LIST_COLUMN_HORIZONTAL_PADDING)
}

const configuredListColumnWidth = (col) => {
  const width = Number(col?.configuredWidth || col?.width || col?.minWidth)
  return Number.isFinite(width) && width > 0 ? width : 0
}

const resolveAutoListColumnWidth = (col) => {
  if (!col) return LIST_COLUMN_MIN_WIDTH
  const configured = configuredListColumnWidth(col)
  if (isImageColumn(col)) return Math.max(configured, 100)

  const samples = [String(col.label || '')]
  tableData.value.forEach((row) => {
    const text = getRawListCellText(col, row)
    if (text) samples.push(truncateListText(text, LIST_CELL_DEFAULT_CHARS))
  })
  const contentWidth = Math.max(...samples.map(estimateListTextWidth), LIST_COLUMN_MIN_WIDTH)

  if (isCompactListColumn(col)) {
    return Math.min(Math.max(contentWidth, configured || LIST_COLUMN_MIN_WIDTH), 140)
  }
  return Math.min(Math.max(contentWidth, LIST_COLUMN_MIN_WIDTH), LIST_COLUMN_MAX_INITIAL_WIDTH)
}

const resolveListColumnWidth = (col) => {
  const prop = String(col?.prop || '')
  const resizedWidth = Number(listColumnWidths.value[prop])
  if (Number.isFinite(resizedWidth) && resizedWidth > 0) return resizedWidth
  return resolveAutoListColumnWidth(col)
}

const listCellCharLimit = (col) => {
  const prop = String(col?.prop || '')
  if (!resizedListColumns.value[prop]) return LIST_CELL_DEFAULT_CHARS
  const width = Number(listColumnWidths.value[prop]) || resolveListColumnWidth(col)
  const addedChars = Math.floor(
    Math.max(width - resolveAutoListColumnWidth(col), 0) / LIST_COLUMN_CJK_CHAR_WIDTH
  )
  return Math.min(LIST_CELL_DEFAULT_CHARS + addedChars, LIST_CELL_MAX_CHARS)
}

const handleListColumnResize = (newWidth, _oldWidth, column) => {
  const prop = String(column?.property || '')
  if (!prop || !(schema.value.columns || []).some((col) => String(col.prop) === prop)) return
  const width = Math.max(Math.round(Number(newWidth) || 0), LIST_COLUMN_MIN_WIDTH)
  listColumnWidths.value = { ...listColumnWidths.value, [prop]: width }
  resizedListColumns.value = { ...resizedListColumns.value, [prop]: true }
}

const getRawListCellText = (col, row) => {
  if (!col || !row) return ''
  if (isDictColumn(col)) {
    const raw = row[col.prop] ?? row[col.voProp]
    return dictLabel(resolveDictCode(col), raw) || ''
  }
  if (isReferenceColumn(col)) {
    return resolveRefLabel(col, columnValue(col, row)) || ''
  }
  const val = formatListCellText(col, row)
  if (val == null || val === '') return ''
  return String(val)
}

const displayListCellText = (col, row) => {
  const text = getRawListCellText(col, row)
  const str = text == null ? '' : String(text)
  if (!str) return undefined
  return truncateListText(str, listCellCharLimit(col))
}

const listCellTitle = (col, row) => {
  const text = getRawListCellText(col, row)
  const str = text == null ? '' : String(text)
  const visibleText = truncateListText(str, listCellCharLimit(col))
  const isClipped = estimateListTextWidth(visibleText) > resolveListColumnWidth(col)
  return listTextCharacters(str).length > listCellCharLimit(col) || isClipped ? str : undefined
}

const isConfigValueColumn = (col) => {
  const prop = String(col?.prop || '').toLowerCase()
  return ['value', 'configvalue', 'config_value'].includes(prop)
}

/** 网站设置：类型为图片时，变量值列展示缩略图（web_config_type: 2=图片） */
const isWebConfigImageValue = (col, row) => {
  if (!col || !row || props.formCode !== 'Config') return false
  const prop = String(col.prop || '').toLowerCase()
  if (!isConfigValueColumn(col)) return false
  const typeVal = row.type ?? row.configType ?? row.config_type
  return String(typeVal) === '2'
}

/** 网站设置：类型为开关时，变量值列展示开/关（web_config_type: 4=开关） */
const isWebConfigSwitchValue = (col, row) => {
  if (!col || !row || props.formCode !== 'Config') return false
  if (!isConfigValueColumn(col)) return false
  const typeVal = row.type ?? row.configType ?? row.config_type
  return String(typeVal) === '4'
}

const isConfigSwitchOn = (row) => {
  const val = row?.value ?? row?.configValue ?? row?.config_value
  return val === 1 || val === '1' || val === true
}

const isImageLikeCell = (col, row) => isImageColumn(col) || isWebConfigImageValue(col, row)

const dictCodeMap = computed(() => {
  const map = {}
  ;(schema.value.formFields || []).forEach((f) => {
    const code = f.dictCode || f.dictcode || f.dict_key || f.dictKey
    if (code && f.prop) {
      map[f.prop] = code
    }
  })
  return map
})

const resolveDictCode = (col) => {
  if (!col) return undefined
  return col.dictCode || col.dictcode || col.dict_key || col.dictKey || dictCodeMap.value[col.prop]
}

const isDictColumn = (col) => {
  return !!resolveDictCode(col)
}

const columnValue = (col, row) => {
  if (!col || !row) return undefined
  const voProp = col.voProp || col.voprop || col.vo_prop
  if (voProp && row[voProp] !== undefined) return row[voProp]
  const autoNameProp = col.prop ? `${col.prop}Name` : undefined
  if (autoNameProp && row[autoNameProp] !== undefined) return row[autoNameProp]
  const value = row[col.prop]
  if (col.prop === 'type') {
    console.log('[columnValue] type - typeof row:', typeof row, 'row constructor:', row?.constructor?.name)
    console.log('[columnValue] type - row is Proxy?', row?.constructor?.name === 'Object' && Object.getPrototypeOf(row) !== Object.prototype)
    console.log('[columnValue] type - all keys:', Object.keys(row), Object.getOwnPropertyNames(row))
    console.log('[columnValue] type - value:', value, 'tableData[0]?.type:', tableData.value?.[0]?.type)
  }
  return value
}

const dictLabel = (code, value) => {
  if (!code) return value ?? '-'
  const opts = dictCache.value[code] || []
  if (code === 'web_config_type') {
    console.log('[dictLabel] web_config_type - value:', value, 'opts:', opts, 'opts.length:', opts.length)
  }
  const match = opts.find((opt) => String(opt.value) === String(value))
  return match ? match.label : value ?? '-'
}

const productRowImage = (row) => row?.image || row?.productImage || ''
const productRowName = (row) => row?.title || row?.name || '-'
const productRowCode = (row) => row?.code || '-'
const productRowType = (row) => row?.productType ?? row?.product_type
const productRowTypeLabel = (row) => {
  const val = productRowType(row)
  if (val === null || val === undefined || val === '') return '-'
  const match = productTypeOptions.value.find((opt) => String(opt.value) === String(val))
  return match?.label || String(val)
}
const imagePreviewVisible = ref(false)
const imagePreviewUrl = ref('')
const openImagePreview = (src) => {
  if (!src) return
  imagePreviewUrl.value = normalizeImgUrl(src)
  imagePreviewVisible.value = true
}
const openProductImagePreview = (row) => {
  openImagePreview(productRowImage(row))
}

const productMpPreviewVisible = ref(false)
const productMpPreviewId = ref(null)
const handleProductDetailPreview = (row) => {
  const pk = schema.value.idField || 'id'
  const id = row?.[pk] ?? row?.id ?? row?.productId
  if (!id) {
    ElMessage.warning('无法获取商品ID')
    return
  }
  productMpPreviewId.value = id
  productMpPreviewVisible.value = true
}
const handleLotteryDraw = async (row) => {
  const id = row?.id
  if (!id) return
  try {
    await ElMessageBox.confirm('确认手动开奖？（调试模式，忽略时间限制）', '提示', { type: 'warning' })
  } catch {
    return
  }
  try {
    const res = await axios.post(`/api/lottery-activities/${id}/draw?force=1`)
    if (res.data?.code === 200) {
      ElMessage.success(res.data?.msg || '开奖成功')
      loadData()
    } else {
      ElMessage.error(res.data?.msg || '开奖失败')
    }
  } catch (e) {
    ElMessage.error(e?.response?.data?.msg || e.message || '开奖失败')
  }
}
const productRowStock = (row) => {
  const val = row?.totalStock ?? row?.total_stock ?? row?.stock
  return val === null || val === undefined || val === '' ? 0 : val
}
const productRowSales30d = (row) => {
  const val = row?.sales30d ?? row?.sales_30d ?? row?.sales
  return val === null || val === undefined || val === '' ? 0 : val
}
const productRowHistorySales = (row) => {
  const val = row?.historySales ?? row?.history_sales
  return val === null || val === undefined || val === '' ? 0 : val
}
const formatProductPrice = (price) => {
  if (price === null || price === undefined || price === '') return '-'
  const num = Number(price)
  if (Number.isNaN(num)) return price
  return `¥${num.toFixed(2)}`
}

const normalizeKeys = (obj) => {
  if (!obj || typeof obj !== 'object') return obj
  const out = {}
  Object.keys(obj).forEach((k) => {
    out[toCamel(k)] = obj[k]
  })
  return out
}

const toCamel = (str) => {
  if (!str) return ''
  return String(str).replace(/[_-](\w)/g, (_m, c) => (c ? c.toUpperCase() : '')).replace(/^([A-Z])/, (m) => m.toLowerCase())
}

const toBool = (v, def = false) => {
  if (v === undefined || v === null) return def
  if (typeof v === 'boolean') return v
  if (typeof v === 'number') return v !== 0
  if (typeof v === 'string') return ['1', 'true', 'yes', 'on'].includes(v.toLowerCase())
  return def
}

const forceHide = (field) => {
  const f = (field || '').toLowerCase()
  return ['id', 'createuser', 'createuser_id', 'create_time', 'createtime', 'updateuser', 'updateuser_id', 'update_time', 'updatetime', 'is_deleted', 'isdeleted'].includes(f)
}

const isAuditField = (field) => {
  const f = (field || '').toLowerCase()
  return ['create_time', 'createtime', 'create_user', 'createuser', 'update_time', 'updatetime', 'update_user', 'updateuser', 'is_deleted', 'isdeleted'].includes(f)
}

const shouldShowInList = (field) => {
  const f = (field || '').toLowerCase()
  return ['create_time', 'createtime', 'create_user', 'createuser', 'update_time', 'updatetime', 'update_user', 'updateuser'].includes(f)
}

const resolveComponent = (field) => {
  const tp = mapType(field.type)
  if (tp === 'richtext') return 'RichTextEditor'
  if (tp === 'textarea') return 'el-input'
  if (tp === 'select') return 'el-select'
  if (tp === 'category-tree') return 'category-tree'
  if (tp === 'number') return 'el-input'
  if (tp === 'upload' || tp === 'image') return 'el-upload'
  return 'el-input'
}

const resolveFieldPlaceholder = (field) => {
  const custom = String(field?.placeholder ?? '').trim()
  if (custom) return custom
  return field?.label || field?.prop || ''
}

const resolveAttrs = (field) => {
  const tp = mapType(field.type)
  const placeholder = resolveFieldPlaceholder(field)
  if (tp === 'textarea') return { type: 'textarea', rows: 3, placeholder }
  if (tp === 'number') return { type: 'number', placeholder }
  if (tp === 'select') {
    const attrs = { placeholder, clearable: true, filterable: true }
    // 如果有 options，添加到属性中
    if (field.options && Array.isArray(field.options) && field.options.length) {
      attrs.options = field.options
    }
    return attrs
  }
  if (tp === 'upload' || tp === 'image') {
    return {
      drag: true,
      'list-type': 'picture-card',
      'show-file-list': true,
      'auto-upload': true,
      multiple: !!field.multiple,
      action: '/api/upload/image',
      name: 'file',
    }
  }
  return { placeholder }
}

const mergeConfig = async () => {
  const base = API_MAP[props.formCode] || {}
  const next = {
    title: props.pageTitle || base.title || props.formCode,
    listApi: base.listApi,
    submitApi: base.submitApi,
    removeApi: base.removeApi,
    keywordFields: base.keywordFields || [],
    idField: 'id',
    columns: [],
    formFields: [],
  }

  let layoutFields = []
  let categoriesCfg = []
  let targetConfig = null
  let fieldConfigId = null
  try {
    await ensureFormConfigs()
    const configs = formConfigs.value || []
    if (isTypeBoundForm.value) {
      targetConfig = findProductConfigByType(configs, currentProductType.value)
      fieldConfigId = targetConfig?.id ?? null
    } else if (isLotteryActivityForm.value) {
      targetConfig = resolveLotteryActivityConfig()
      if (targetConfig?.id) {
        selectedConfigId.value = targetConfig.id
        fieldConfigId = targetConfig.id
      }
    } else {
      targetConfig = await resolveGenericConfig()
      fieldConfigId = targetConfig?.id ?? null
    }

    let layoutConfig = targetConfig
    if (isTypeBoundForm.value && isConfigFormJsonEmpty(targetConfig)) {
      const defaultConfig = findDefaultProductConfig(configs)
      if (defaultConfig && defaultConfig.id !== targetConfig?.id) {
        layoutConfig = defaultConfig
      }
    }

    const formJson = parseConfigFormJson(layoutConfig)
    layoutFields = formJson.fields || []
    categoriesCfg = formJson.categories || []
  } catch (e) {
    console.warn('加载表单配置失败', e)
  }

  // 2) 字段属性
  let fieldDefs = []
  try {
    const params = { schemaCode: props.formCode }

    if (fieldConfigId) {
      params.configId = fieldConfigId
    } else if (props.formCode === 'Product' && currentProductType.value !== null && currentProductType.value !== undefined) {
      try {
        const configRes = await axios.get('/api/meta-form-configs/by-schema/Product')
        const configs = configRes.data?.data || []
        const matchedConfig = findProductConfigByType(configs, currentProductType.value)
        if (matchedConfig?.id) {
          params.configId = matchedConfig.id
          fieldConfigId = matchedConfig.id
        }
      } catch (e) {
        console.warn('获取配置ID失败', e)
      }
    }
    
    const fieldRes = await axios.get('/api/meta/schemas/fields', { params })
    const fieldList = (fieldRes.data && fieldRes.data.data) || fieldRes.data || []
    fieldDefs = Array.isArray(fieldList) ? fieldList : []

    if (!fieldDefs.length && props.formCode === 'Product' && fieldConfigId) {
      const defaultConfig = findDefaultProductConfig(formConfigs.value || [])
      if (defaultConfig?.id && defaultConfig.id !== fieldConfigId) {
        const fallbackRes = await axios.get('/api/meta/schemas/fields', {
          params: { schemaCode: props.formCode, configId: defaultConfig.id },
        })
        const fallbackList = (fallbackRes.data && fallbackRes.data.data) || fallbackRes.data || []
        fieldDefs = Array.isArray(fallbackList) ? fallbackList : []
      }
    }
  } catch (e) {
    console.warn('加载字段配置失败', e)
  }

  const defMap = {}
  fieldDefs.forEach((f) => { defMap[toCamel(f.field)] = f })
  const merged = []
  const seenKeys = new Set()
  layoutFields.forEach((lf) => {
    if (!lf || !lf.field) return
    const key = toCamel(lf.field)
    const category = lf.category || '基础设置'
    const uniqueKey = `${key}__${category}`
    if (seenKeys.has(uniqueKey)) return
    const def = defMap[key] || {}
    const col = {
      prop: key,
      field: lf.field,
      label: lf.label || def.label || lf.field,
      placeholder: lf.placeholder || def.placeholder || '',
      configuredWidth: Number(lf.listWidth || lf.width || def.listWidth || def.width) || undefined,
      width: lf.width,
      type: lf.type || lf.fieldType || def.formType || def.dataType || def.type,
      dictCode: lf.dictCode || lf.dict_code || def.dictCode || def.dict_code,
      voProp: lf.voProp || lf.vo_prop || def.voProp || def.vo_prop,
      hidden: toBool(lf.hidden ?? def.hidden),
      displayRules: lf.displayRules || null,
      listHidden: toBool(lf.listHidden ?? def.listHidden ?? def.list_hidden),
      formHidden: toBool(lf.hidden ?? def.hidden),
      required: toBool(lf.required ?? def.required),
      editable: lf.editable !== false && def.editable !== false && def.editable !== 0,
      order: lf.order ?? def.orderNo ?? def.order_no,
      category: category,
      isSubTable: lf.isSubTable,
      parentField: lf.parentField,
      childSchemaCode: lf.childSchemaCode,
      apiUrl: lf.apiUrl || def.apiUrl || def.api_url,
      dependsOn: lf.dependsOn || def.dependsOn || def.depends_on,
      refKey: lf.refKey || lf.ref_key || def.refKey || def.ref_key,
    }
    merged.push(col)
    seenKeys.add(uniqueKey)
  })
  const layoutFieldKeys = new Set(layoutFields.map((lf) => toCamel(lf.field)).filter(Boolean))
  fieldDefs.forEach((def) => {
    const key = toCamel(def.field)
    if (layoutFieldKeys.has(key)) return
    const category = def.category || '基础设置'
    const uniqueKey = `${key}__${category}`
    if (seenKeys.has(uniqueKey)) {
      return
    }
    
    const col = {
      prop: key,
      label: def.label || def.field,
      placeholder: def.placeholder || '',
      configuredWidth: Number(def.listWidth || def.width) || undefined,
      type: def.formType || def.dataType || def.type,
      dictCode: def.dictCode || def.dict_code,
      voProp: def.voProp || def.vo_prop,
      hidden: toBool(def.hidden),
      listHidden: toBool(def.listHidden ?? def.list_hidden),
      formHidden: toBool(def.hidden),
      required: toBool(def.required),
      editable: def.editable !== false && def.editable !== 0,
      order: def.orderNo ?? def.order_no,
      category: category,
      apiUrl: def.apiUrl || def.api_url,
      dependsOn: def.dependsOn || def.depends_on,
      refKey: def.refKey || def.ref_key,
    }
    merged.push(col)
    seenKeys.add(uniqueKey)
  })

  const columnsWithDefaults = merged.length ? merged : (API_MAP[props.formCode]?.columns || [])

  // 特殊处理：ProductModule 的 product_id 显示 productName
  if (props.formCode === 'ProductModule') {
    columnsWithDefaults.forEach(col => {
      if (col.prop === 'productId' || col.prop === 'product_id') {
        col.voProp = col.voProp || 'productName'
      }
    })
  }

  const ordered = columnsWithDefaults.sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
  const normalizeWidth = (w) => {
    if (w === '100%' || w === '50%' || w === '33%') return w
    return '100%'
  }
  if (props.formCode === 'Product') {
    next.columns = []
  } else {
    next.columns = ordered
      .filter((f) => {
        if (f.isSubTable) return false
        if (isAuditField(f.prop)) {
          return shouldShowInList(f.prop)
        }
        return !toBool(f.listHidden)
      })
      .map((f) => {
        const col = {
          prop: f.prop,
          label: f.label,
          configuredWidth: configuredListColumnWidth(f),
          dictCode: f.dictCode,
          voProp: f.voProp,
          type: f.type,
          refKey: f.refKey,
        }
        if (f.prop === 'type') {
          console.log('[columns] type field:', col)
        }
        return col
      })
  }

  console.log('[formFields] total fields:', ordered.length)
  const subTableFields = ordered.filter(f => {
    const cat = categoriesCfg.find(c => c.name === (f.category || '基础设置'))
    return f.isSubTable || (cat?.isSubTable === true)
  })
  console.log('[formFields] subtable fields:', subTableFields.map(f => ({ prop: f.prop, type: f.type, category: f.category })))
  
  const typeField = ordered.find(f => f.prop === 'type')
  if (typeField) {
    console.log('[formFields] type field before mapping:', typeField)
  }
  
  next.formFields = ordered.map((f) => {
    const width = normalizeWidth(f.width)
    const cat = categoriesCfg.find(c => c.name === (f.category || '基础设置'))
    // 硬编码：审计字段在表单中默认隐藏
    const isAudit = isAuditField(f.prop)
    
    // 如果字段没有 isSubTable 属性，但所属分类是子表，则继承分类的子表属性
    const isSubTable = f.isSubTable || toBool(cat?.isSubTable)
    const parentField = (toBool(cat?.isSubTable) && cat?.field) ? cat.field : (f.parentField || cat?.field || (isSubTable ? 'specs' : undefined))
    const childSchemaCode = f.childSchemaCode || cat?.childSchemaCode
    
    // 特殊处理：变量值字段根据类型字段动态渲染
    const isDynamicField = f.prop === 'value' && ordered.some(field => field.prop === 'type')
    
    return {
      prop: f.prop,
      field: f.field || f.prop,
      label: f.label,
      placeholder: f.placeholder || '',
      type: f.type,
      typeExplicit: f.typeExplicit,
      component: resolveComponent(f),
      attrs: resolveAttrs(f),
      width,
      widthExplicit: width === '100%' || width === '50%' || width === '33%',
      required: toBool(f.required),
      hidden: isAudit ? true : toBool(f.formHidden),
      category: f.category || '基础设置',
      categoryOrder: cat?.order ?? 0,
      order: f.order ?? 0,
      dictCode: f.dictCode || f.dictcode || f.dictKey || f.dict_key,
      refKey: f.refKey || f.ref_key,
      isSubTable: isSubTable,
      parentField: parentField,
      childSchemaCode: childSchemaCode,
      options: f.options,
      multiple: toBool(f.multiple),
      dynamicType: isDynamicField,
      dependsOn: isDynamicField ? 'type' : (f.dependsOn || undefined),
      apiUrl: f.apiUrl || undefined,
      pageSize: f.pageSize || f.size || undefined,
      optionValuePrefix: f.optionValuePrefix || f.option_value_prefix || f.optionPrefix || undefined,
      displayRules: f.displayRules || undefined,
    }
  })

  // 保留分类列表，便于后续扩展或调试
  next.categories = categoriesCfg

  applyArticleFormOverrides(next)
  applyProductLabelsOverride(next)
  applyHomeConfigFormOverrides(next)

  listColumnWidths.value = {}
  resizedListColumns.value = {}
  schema.value = next
  
  console.log('=== MetaDynamicForm 字段加载完成 ===')
  console.log('formFields 数量:', schema.value.formFields?.length)
  console.log('province 字段:', schema.value.formFields?.find(f => f.prop === 'province'))
  console.log('city 字段:', schema.value.formFields?.find(f => f.prop === 'city'))
  console.log('district 字段:', schema.value.formFields?.find(f => f.prop === 'district'))

  // 预加载字典选项，避免进入表单模式时无数据
  for (const f of schema.value.formFields || []) {
    const code = f.dictCode || f.dictcode || f.dictKey || f.dict_key
    if (code) {
      // eslint-disable-next-line no-await-in-loop
      f.options = await loadDictOptions(code)
    }
  }

  // 预加载参照（表单下拉 + 列表 ID→名称，与表单 refKey 配置一致）
  await preloadForFormAndList(schema.value.formFields, schema.value.columns)
}

const syncDraftFilters = () => {
  draftKeyword.value = keyword.value
  draftProductCode.value = productCodeFilter.value
  draftProductName.value = productNameFilter.value
  draftProductType.value = productTypeFilter.value
  draftDesignerQuery.value = designerQueryFilter.value
  draftSelectedConfigId.value = selectedConfigId.value
}

const resetDraftFilters = () => {
  draftKeyword.value = ''
  draftProductCode.value = ''
  draftProductName.value = ''
  draftProductType.value = null
  draftDesignerQuery.value = null
  if (formConfigs.value.length) {
    draftSelectedConfigId.value = formConfigs.value[0]?.id ?? null
  } else {
    draftSelectedConfigId.value = null
  }
}

const applyFilters = async () => {
  const configChanged = String(selectedConfigId.value ?? '') !== String(draftSelectedConfigId.value ?? '')
  keyword.value = draftKeyword.value
  productCodeFilter.value = draftProductCode.value
  productNameFilter.value = draftProductName.value
  productTypeFilter.value = draftProductType.value
  designerQueryFilter.value = showProductDesignerQuery.value ? draftDesignerQuery.value : null
  selectedConfigId.value = draftSelectedConfigId.value
  page.value.current = 1
  if (configChanged) {
    await mergeConfig()
  }
  loadData()
}

const { filterVisible, toggleFilter } = useListFilterPanel(syncDraftFilters)

const loadData = async () => {
  if (!schema.value.listApi) return
  loading.value = true
  try {
    const params = { current: page.value.current, size: page.value.size }
    if (keyword.value && schema.value.keywordFields) {
      params.keyword = keyword.value
    }
    if (productNameFilter.value) {
      params.productName = productNameFilter.value
    }
    if (productCodeFilter.value) {
      params.productCode = productCodeFilter.value
    }
    if (props.formCode === 'Product') {
      if (showProductDesignerQuery.value && designerQueryFilter.value) {
        params.designerQuery = designerQueryFilter.value
      }
      if (productTypeFilter.value !== null && productTypeFilter.value !== undefined && productTypeFilter.value !== '') {
        const typeVal = Number(productTypeFilter.value)
        if (!Number.isNaN(typeVal)) {
          params.productType = typeVal
          params.product_type = typeVal
        }
      }
      const status = productTabStatusMap[productActiveTab.value]
      if (status !== undefined) {
        params.status = status
      }
    }
    if (isOrderForm.value) {
      const status = orderTabStatusMap[orderActiveTab.value]
      if (status !== null && status !== undefined) {
        params.status = status
      }
    }
    if (isLotteryOrderForm.value) {
      const status = lotteryOrderTabMap[lotteryOrderTab.value]
      if (status !== null && status !== undefined) {
        params.status = status
      }
    }
    if (showCommonStatusTabs.value) {
      const status = commonStatusTabMap[commonStatusTab.value]
      if (status !== null && status !== undefined) {
        params.status = status
      }
    }
    if (isLotteryActivityForm.value) {
      params.drawType = currentLotteryDrawType.value
      if (showLotteryStatusTabs.value && lotteryStatusTab.value) {
        params.activityStatus = lotteryStatusTab.value
      }
    }
    const res = await axios.get(schema.value.listApi, { params })
    const data = res?.data?.data || res?.data || {}
    const pk = schema.value.idField || 'id'
    const records = (data.records || []).map((item, index) => {
      const row = normalizeKeys(item)
      if (index === 0) {
        console.log('[loadData] first item:', item)
        console.log('[loadData] first row after normalizeKeys:', row)
        console.log('[loadData] row.type:', row.type)
      }
      // sanitize image fields (icon/img/image) to drop blob urls and normalize
      Object.keys(row || {}).forEach((k) => {
        const lk = k.toLowerCase()
        if (lk.includes('avatar') || lk.includes('icon') || lk.includes('img') || lk.includes('image')) {
          const v = row[k]
          if (v && String(v).startsWith('blob:')) {
            row[k] = ''
          } else if (/images|specimages|detailimages|carousel|displayimages|图集|详情/.test(lk) || String(v || '').includes('[')) {
            // 多图 JSON 字段不在列表阶段拼域名，避免 specImages 被拆坏
          } else {
            row[k] = normalizeImgUrl(v)
          }
        }
      })
      return row
    })
    tableData.value = records
    page.value.total = data.total || 0
    loading.value = false

    const preloadTask = (async () => {
      if (props.formCode !== 'Product') {
        for (const col of schema.value.columns || []) {
          const code = resolveDictCode(col)
          if (code) {
            await loadDictOptions(code)
          }
        }
        await preloadForFormAndList(schema.value.formFields, schema.value.columns)
      } else {
        // 商品列表不预加载参照，避免与缩略图加载争用主线程
      }
    })()
    preloadTask.catch((e) => console.warn('列表预加载失败', e))
  } finally {
    if (loading.value) loading.value = false
  }
}

const changePage = (currentPage) => {
  page.value.current = currentPage
  loadData()
}

const changeSize = (size) => {
  page.value.size = size
  page.value.current = 1
  loadData()
}

const handleProductTabClick = (tab) => {
  page.value.current = 1
  // 使用 nextTick 确保 v-model 更新后再加载数据
  nextTick(() => {
    loadData()
  })
}

const handleLotteryStatusTabClick = () => {
  page.value.current = 1
  nextTick(() => {
    loadData()
  })
}

const handleLotteryTabClick = (tab) => {
  const paneName = tab?.paneName
  if (paneName) {
    lotteryActiveTab.value = paneName
  }
  page.value.current = 1
  nextTick(async () => {
    const cfg = resolveLotteryActivityConfig()
    if (cfg?.id) {
      selectedConfigId.value = cfg.id
    }
    await mergeConfig()
    loadData()
  })
}

const handleOrderTabClick = () => {
  page.value.current = 1
  nextTick(() => {
    loadData()
  })
}

const handleLotteryOrderTabClick = () => {
  page.value.current = 1
  nextTick(() => {
    loadData()
  })
}

const handleCommonStatusTabClick = () => {
  page.value.current = 1
  nextTick(() => {
    loadData()
  })
}

const onSelectionChange = (rows) => {
  selectedIds.value = (rows || []).map((r) => r[schema.value.idField || 'id']).filter(Boolean)
  if (!current.value && rows && rows.length) {
    current.value = rows[0]
  }
}

const openRoleAssign = async () => {
  if (!selectedIds.value.length) return
  // 角色下拉
  if (!roleOptions.value.length) {
    const resRoles = await axios.get('/api/roles', { params: { current: 1, size: 1000 } })
    const records = resRoles?.data?.data?.records || resRoles?.data?.records || []
    roleOptions.value = records.map((r) => ({ id: String(r.id), label: r.roleName || r.roleCode || r.id }))
  }
  // 用首个选中管理员回显已绑定角色（多选时同一套角色）
  const firstId = selectedIds.value[0]
  if (firstId) {
    const res = await axios.get(`/api/admins/${firstId}/roles`)
    roleCheckedIds.value = (res?.data?.data || res?.data || []).map((id) => String(id))
  } else {
    roleCheckedIds.value = []
  }
  roleDialogVisible.value = true
}

const submitRoleAssign = async () => {
  if (!selectedIds.value.length) return
  roleSubmitLoading.value = true
  try {
    const payload = roleCheckedIds.value.map((id) => Number(id))
    for (const aid of selectedIds.value) {
      await axios.post(`/api/admins/${aid}/bind-roles`, payload)
    }
    ElMessage.success('角色分配成功')
    roleDialogVisible.value = false
  } finally {
    roleSubmitLoading.value = false
  }
}

const handleResetPassword = async () => {
  if (!selectedIds.value.length) return
  await resetPasswordForIds(selectedIds.value)
}

const handleResetPasswordRow = async (row) => {
  const pk = schema.value.idField || 'id'
  const id = row?.[pk]
  if (!id) {
    ElMessage.warning('无法获取记录ID')
    return
  }
  await resetPasswordForIds([id])
}

const fetchDefaultSitePassword = async () => {
  const res = await axios.get('/api/configs/list', { params: { current: 1, size: 200 } })
  const data = res?.data?.data || res?.data || {}
  const list = Array.isArray(data) ? data : data.records || []
  const target = list.find((item) => (item.configKey || item.key || item.name) === 'site.password')
  return target?.configValue || target?.value || target?.config_value || target?.val || '123456'
}

const resetPasswordForIds = async (ids) => {
  if (!ids?.length) return
  try {
    const defaultPassword = await fetchDefaultSitePassword()
    const subject = props.formCode === 'Admin' ? '管理员' : '用户'
    const name = ids.length === 1 ? '该' : `选中的 ${ids.length} 个`
    await ElMessageBox.confirm(
      `确认将${name}${subject}的密码重置为网站设置中的默认密码（site.password）：${defaultPassword}？`,
      '重置密码确认',
      { type: 'warning' }
    )
    const resetApi = props.formCode === 'Admin' ? '/api/admins/reset-password' : '/api/users/reset-password'
    await axios.post(resetApi, {
      ids,
      password: defaultPassword,
    })
    ElMessage.success('密码重置成功')
    loadData()
  } catch (e) {
    if (e !== 'cancel') {
      ElMessage.error(e.response?.data?.msg || e.response?.data?.message || '密码重置失败')
    }
  }
}

const resetForm = (data = {}) => {
  const empty = getEmptyForm()
  Object.assign(empty, data || {})
  // sanitize upload fields to remove blob urls when editing
  Object.keys(empty).forEach((k) => {
    const lk = k.toLowerCase()
    if (lk.includes('icon') || lk.includes('img') || lk.includes('image')) {
      const v = empty[k]
      if (v && typeof v === 'string' && v.startsWith('blob:')) {
        empty[k] = ''
      }
    }
  })
  if (props.formCode === 'Config' && (String(empty.type) === '4')) {
    empty.value = normalizeConfigSwitchValue(empty.value) === '1' ? 1 : 0
  }
  form.value = empty
}

const handleAdd = () => {
  enterAddFormMode()
}

const enterAddFormMode = () => {
  const customTitle = route.meta?.pageTitle
  formTitle.value = customTitle || `新增${schema.value.title || ''}`
  current.value = null
  currentProductType.value = null
  specsSubTableLoading.value = false
  resetForm()
  if (isLotteryActivityForm.value) {
    form.value.drawType = currentLotteryDrawType.value
  }
  mode.value = 'form'
}

const handleAddProduct = (typeValue) => {
  const typeItem = productTypeOptions.value.find(t => t.value === typeValue)
  formTitle.value = `发布${typeItem?.label || '商品'}`
  currentProductType.value = typeValue
  specsSubTableLoading.value = false
  resetForm()
  mode.value = 'form'
}

const fetchProductDetail = async (id) => {
  if (!id) return null
  try {
    const res = await axios.get(`/api/products/${id}`)
    return res?.data?.data || res?.data || null
  } catch (err) {
    console.warn('加载商品详情失败', err)
    return null
  }
}

const fetchLotteryActivityDetail = async (id) => {
  if (!id) return null
  try {
    const res = await axios.get(`/api/lottery-activities/${id}`)
    return res?.data?.data || res?.data || null
  } catch (err) {
    console.warn('加载抽奖活动详情失败', err)
    return null
  }
}

const PRODUCT_SPEC_PARENT_FALLBACKS = ['specs', 'produec_specs', 'product_specs', 'ProductSpece', 'productSpecs']

const resolveProductSpecParentFields = () => {
  const keys = new Set(PRODUCT_SPEC_PARENT_FALLBACKS)
  ;(schema.value.formFields || []).forEach((f) => {
    if (f.isSubTable && f.parentField) keys.add(f.parentField)
  })
  ;(schema.value.categories || []).forEach((c) => {
    if (toBool(c.isSubTable) && c.field) keys.add(c.field)
  })
  return Array.from(keys)
}

const mapProductSpecsFromDetail = (detail) => {
  if (!detail || !Array.isArray(detail.specs) || !detail.specs.length) return detail
  resolveProductSpecParentFields().forEach((key) => {
    if (!Array.isArray(detail[key]) || !detail[key].length) {
      detail[key] = detail.specs
    }
  })
  return detail
}

const syncProductSpecsToForm = (specsData) => {
  if (!Array.isArray(specsData) || !specsData.length) return
  form.value.specs = specsData
  resolveProductSpecParentFields().forEach((key) => {
    form.value[key] = specsData
  })
}

const clonePlainObject = (value) => {
  if (value === null || value === undefined) return value
  try {
    return JSON.parse(JSON.stringify(value))
  } catch (e) {
    if (Array.isArray(value)) return value.map((item) => ({ ...(item || {}) }))
    if (typeof value === 'object') return { ...value }
    return value
  }
}

const resetProductCopyIdentity = (copy) => {
  if (!copy || typeof copy !== 'object') return copy
  const pk = schema.value.idField || 'id'
  ;[
    pk, 'id', 'code', 'productCode', 'product_code',
    'auditCode', 'audit_code', 'auditStatus', 'audit_status',
    'createTime', 'updateTime', 'createUser', 'updateUser',
    'createUserName', 'updateUserName',
  ].forEach((key) => { delete copy[key] })

  const sourceSpecs = Array.isArray(copy.specs)
    ? copy.specs
    : resolveProductSpecParentFields()
      .map((key) => copy[key])
      .find((value) => Array.isArray(value))

  if (Array.isArray(sourceSpecs)) {
    const nextSpecs = sourceSpecs
      .filter((row) => row && typeof row === 'object')
      .map((row) => {
        const next = { ...row }
        ;[
          'id', 'productId', 'product_id', 'designId', 'design_id',
          'createTime', 'updateTime', 'createUser', 'updateUser',
          'createUserName', 'updateUserName', 'isDeleted', 'deletedAt',
        ].forEach((key) => { delete next[key] })
        return next
      })
    copy.specs = nextSpecs
    resolveProductSpecParentFields().forEach((key) => {
      copy[key] = nextSpecs.map((row) => ({ ...row }))
    })
  }
  return copy
}

const isMeaningfulSpecRow = (row) => {
  if (!row || typeof row !== 'object') return false
  if (row.id) return true
  return !!(row.specName || row.spec_name || row.price || row.stock || row.specImage || row.spec_image)
}

const mapProductSpecsToSubmitPayload = (payload) => {
  const parentFields = resolveProductSpecParentFields()
  for (const key of parentFields) {
    if (Array.isArray(payload[key])) {
      payload.specs = payload[key].filter(isMeaningfulSpecRow)
      parentFields.forEach((k) => {
        if (k !== key) delete payload[k]
      })
      return
    }
  }
}

const loadEditData = async (sourceRow) => {
  if (!sourceRow) return sourceRow
  
  const pk = schema.value.idField || 'id'
  const id = sourceRow[pk]
  
  // Product 模块使用专门的 detail 接口
  if (props.formCode === 'Product') {
    const detail = await fetchProductDetail(id)
    if (detail) {
      return mapProductSpecsFromDetail(detail)
    }
    return sourceRow
  }

  // LotteryActivity 模块使用 detail 接口加载活动奖品子表
  if (props.formCode === 'LotteryActivity' && id) {
    const detail = await fetchLotteryActivityDetail(id)
    if (detail) {
      if (detail.lotteryActivityPrizes && !detail.LotteryActivityPrize) {
        detail.LotteryActivityPrize = detail.lotteryActivityPrizes
      }
      return detail
    }
    return sourceRow
  }
  
  // DesignerAddress 模块调用 detail 接口获取 VO 数据（包含省市区中文名称）
  if (props.formCode === 'Article' && id) {
    try {
      const response = await axios.get(`/api/articles/${id}`)
      const data = response.data?.data || response.data
      if (data) {
        const extractedImages = extractImagesFromHtml(data.content)
        if (data.content) data.content = stripHtmlToPlainText(data.content)
        if (!data.contentImages && data.content_images) {
          data.contentImages = data.content_images
        }
        if ((!data.contentImages || !data.contentImages.length) && extractedImages.length) {
          data.contentImages = extractedImages.map((url) => toRelativeUploadPath(url))
        }
        return data
      }
    } catch (error) {
      console.error('获取文章详情失败:', error)
    }
  }

  if (props.formCode === 'DesignerAddress' && id) {
    try {
      const response = await axios.get(`/api/designer-addresses/${id}`)
      if (response.data && response.data.code === 200) {
        const data = response.data.data
        // 确保省市区字段是数字类型，与选项列表的 value 类型一致
        if (data.province) data.province = Number(data.province)
        if (data.city) data.city = Number(data.city)
        if (data.district) data.district = Number(data.district)
        return data
      }
    } catch (error) {
      console.error('获取地址详情失败:', error)
    }
  }
  
  // Address 模块调用 detail 接口获取 VO 数据（包含省市区中文名称）
  if (props.formCode === 'Address' && id) {
    try {
      const response = await axios.get(`/api/address/${id}`)
      if (response.data && response.data.code === 200) {
        const data = response.data.data
        if (data.province) data.province = Number(data.province)
        if (data.city) data.city = Number(data.city)
        if (data.district) data.district = Number(data.district)
        return data
      }
    } catch (error) {
      console.error('获取收货地址详情失败:', error)
    }
  }
  
  return sourceRow
}

const handleEdit = async () => {
  if (!current.value) return
  await handleEditRow(current.value)
}

const handleRemove = () => {
  if (!selectedIds.value.length) return
  ElMessageBox.confirm(`确认删除选中的 ${selectedIds.value.length} 条记录？`, '提示', { type: 'warning' })
    .then(async () => {
      const ids = selectedIds.value.join(',')
      await axios.post(schema.value.removeApi, null, { params: { ids } })
      ElMessage.success('删除成功')
      selectedIds.value = []
      loadData()
    })
    .catch(() => {})
}

const handleSyncProductModule = async () => {
  productModuleSyncLoading.value = true
  try {
    await syncProductModules()
    ElMessage.success('同步完成')
    loadData()
  } catch (e) {
    console.error(e)
    ElMessage.error('同步失败')
  } finally {
    productModuleSyncLoading.value = false
  }
}

const syncCurrentProductTypeFromRow = async (row, { force = false } = {}) => {
  if (props.formCode !== 'Product' || !row) return
  const raw = row.productType ?? row.product_type
  if (raw === null || raw === undefined || raw === '') return
  const typeVal = Number(raw)
  if (Number.isNaN(typeVal)) return
  if (!force && currentProductType.value === typeVal && (schema.value.formFields || []).length) {
    return
  }
  currentProductType.value = typeVal
  await mergeConfig()
}

const hydrateEditForm = async (row, { rowId } = {}) => {
  const pk = schema.value.idField || 'id'
  const editId = rowId ?? row?.[pk]
  const isStale = () => current.value?.[pk] !== editId || mode.value !== 'form'

  const detailRow = await loadEditData(row)
  if (isStale()) return
  await syncCurrentProductTypeFromRow(detailRow || row)
  if (isStale()) return
  resetForm(detailRow || row)
  if (props.formCode === 'Product' && detailRow) {
    const specsData = detailRow.specs
      || resolveProductSpecParentFields().map((key) => detailRow[key]).find((v) => Array.isArray(v) && v.length)
    syncProductSpecsToForm(specsData)
    await nextTick()
  }
}

const handleEditRow = async (row) => {
  if (!row) return
  const rowId = row[schema.value.idField || 'id']
  formTitle.value = `修改${schema.value.title || ''}`
  current.value = row

  // 先用列表数据立即进入编辑页，避免等待详情/配置接口
  if (props.formCode === 'Product') {
    const raw = row.productType ?? row.product_type
    const typeVal = raw === null || raw === undefined || raw === '' ? null : Number(raw)
    if (typeVal !== null && !Number.isNaN(typeVal)) {
      currentProductType.value = typeVal
    }
  }
  resetForm({ ...row })
  mode.value = 'form'

  const runHydrate = async () => {
    try {
      await hydrateEditForm(row, { rowId })
    } catch (e) {
      console.error('加载编辑数据失败', e)
      ElMessage.error('加载商品详情失败，请重试')
    }
  }

  // 商品：详情/规格后台补全，子表区域单独显示加载中
  if (props.formCode === 'Product') {
    specsSubTableLoading.value = true
    runHydrate().finally(() => {
      specsSubTableLoading.value = false
    })
    return
  }

  formEditLoading.value = true
  try {
    await runHydrate()
  } finally {
    formEditLoading.value = false
  }
}

const handleCopyRow = async (row) => {
  if (!row) return
  formTitle.value = `复制${schema.value.title || ''}`
  let sourceRow = row
  if (props.formCode === 'Product') {
    formEditLoading.value = true
    try {
      await syncCurrentProductTypeFromRow(row, { force: true })
      const detailRow = await loadEditData(row)
      if (detailRow) {
        sourceRow = detailRow
        await syncCurrentProductTypeFromRow(detailRow, { force: true })
      }
    } catch (e) {
      console.error('加载复制商品详情失败', e)
      ElMessage.warning('规格详情加载失败，将仅复制主表信息')
    } finally {
      formEditLoading.value = false
    }
  } else {
    await syncCurrentProductTypeFromRow(row)
  }
  const copy = clonePlainObject(sourceRow) || {}
  delete copy[schema.value.idField || 'id']
  if (props.formCode === 'Product') {
    copy.status = 0
    resetProductCopyIdentity(copy)
  }
  if (isLotteryActivityForm.value) {
    applyLotteryCopyDefaults(copy)
  }
  current.value = null
  resetForm(copy)
  mode.value = 'form'
  if (props.formCode === 'Product') {
    const specsData = copy.specs
      || resolveProductSpecParentFields().map((key) => copy[key]).find((v) => Array.isArray(v) && v.length)
    syncProductSpecsToForm(specsData)
    await nextTick()
  }
}

const handleBatchCreateFromCards = () => {
  ElMessageBox.confirm('确认为所有尚未关联批次的卡片创建批次记录？（不生成二维码图片）', '提示', { type: 'warning' })
    .then(async () => {
      const res = await axios.post('/api/qrcode-batches/batch-create-from-cards')
      if (res.data?.code !== 200 && res.data?.success !== true) {
        throw new Error(res.data?.msg || '操作失败')
      }
      const data = res.data?.data || {}
      ElMessage.success(`已创建 ${data.created || 0} 个批次，跳过 ${data.skipped || 0} 个`)
      loadData()
    })
    .catch((e) => {
      if (e !== 'cancel' && e?.message) ElMessage.error(e.message)
    })
}

const resolveRowId = (row) => {
  if (!row) return null
  return row[schema.value.idField || 'id']
}

const handleQrcodeGenerate = (row) => {
  const id = resolveRowId(row)
  if (!id) return ElMessage.warning('无法获取批次ID')
  ElMessageBox.prompt('请输入本次生成数量', '生成二维码', {
    confirmButtonText: '开始生成',
    cancelButtonText: '取消',
    inputPattern: /^[1-9]\d*$/,
    inputErrorMessage: '请输入大于0的整数',
    inputValue: '1',
  })
    .then(async ({ value }) => {
      const res = await axios.post('/api/qrcode-batches/do-generate', { id, quantity: Number(value) })
      if (res.data?.code !== 200 && res.data?.success !== true) {
        throw new Error(res.data?.msg || '生成失败')
      }
      const data = res.data?.data || {}
      ElMessage.success(`成功 ${data.success || 0} 个${data.failed ? `，失败 ${data.failed} 个` : ''}`)
      loadData()
    })
    .catch((e) => {
      if (e !== 'cancel' && e?.message) ElMessage.error(e.message)
    })
}

const handleQrcodeDownload = async (row) => {
  const id = resolveRowId(row)
  if (!id) return ElMessage.warning('无法获取批次ID')
  try {
    const check = await axios.get('/api/qrcode-batches/check-download', { params: { id } })
    if (check.data?.code !== 200 && check.data?.success !== true) {
      throw new Error(check.data?.msg || '暂无可下载的二维码')
    }
    window.open(`/api/qrcode-batches/download-zip?id=${id}`, '_blank')
  } catch (e) {
    ElMessage.error(e?.message || '下载失败')
  }
}

const showShelfButton = (row) => {
  if (isAccountForm.value || isOrderForm.value || isLotteryOrderForm.value || isDesignerForm.value || isConfigForm.value || isCardForm.value || isQrcodeForm.value) {
    return false
  }
  if (props.formCode === 'Product') {
    const status = row?.status
    return status === 0 || status === 2 || status === 3 || status === 4
  }
  return true
}

const shelfButtonLabel = (row) => {
  if (props.formCode === 'Product') {
    return row?.status === 2 ? '下架' : '上架'
  }
  if (props.pageTitle === '新品体验馆') {
    return row?.status === 1 ? '结束' : '启用'
  }
  return row?.status === 1 ? '下架' : '上架'
}

const shelfButtonType = (row) => {
  if (props.formCode === 'Product') {
    return row?.status === 2 ? 'danger' : 'success'
  }
  return row?.status === 1 ? 'danger' : 'success'
}

const handleProductShelfToggle = (row) => {
  const id = row[schema.value.idField || 'id']
  if (!id) return
  const status = row.status
  const title = row.title || row.name || row.productName || ''
  if (status === 2) {
    const tip = title ? `确认下架「${title}」？` : '确认下架该商品？'
    ElMessageBox.confirm(tip, '下架确认', { type: 'warning', confirmButtonText: '确认下架', cancelButtonText: '取消' })
      .then(async () => {
        const res = await axios.post(`/api/products/off-shelf/${id}`)
        if (res.data?.code !== 200 && res.data?.success !== true) {
          throw new Error(res.data?.msg || '下架失败')
        }
        ElMessage.success('下架成功')
        loadData()
      })
      .catch((e) => {
        if (e !== 'cancel' && e?.message) ElMessage.error(e.message)
      })
    return
  }
  if (status === 0 || status === 3 || status === 4) {
    const tip = title
      ? `确认上架「${title}」并提交审核？上架后将进入审核流程。`
      : '确认上架并提交审核？上架后将进入审核流程。'
    ElMessageBox.confirm(tip, '上架确认', { type: 'warning', confirmButtonText: '确认上架', cancelButtonText: '取消' })
      .then(async () => {
        const res = await axios.post(`/api/products/submit-audit/${id}`)
        if (res.data?.code !== 200 && res.data?.success !== true) {
          throw new Error(res.data?.msg || '提交审核失败')
        }
        ElMessage.success('已提交审核')
        loadData()
      })
      .catch((e) => {
        if (e !== 'cancel' && e?.message) ElMessage.error(e.message)
      })
    return
  }
  if (status === 1) {
    ElMessage.info('商品审核中，请耐心等待')
  }
}

const handleToggleStatusRow = (row) => {
  if (!row) return
  const id = row[schema.value.idField || 'id']
  if (!id) return
  if (props.formCode === 'Product') {
    handleProductShelfToggle(row)
    return
  }
  const entity = props.formCode
  const isXinPin = props.pageTitle === '新品体验馆'
  const action = row.status === 1 ? (isXinPin ? '结束' : '下架') : (isXinPin ? '启用' : '上架')
  const title = row.title || row.name || row.productName || ''
  const tip = title ? `是否${action}「${title}」？` : `是否${action}该记录？`
  ElMessageBox.confirm(tip, '提示', { type: 'warning', confirmButtonText: `确认${action}`, cancelButtonText: '取消' })
    .then(async () => {
      await axios.post('/api/common/toggleStatus', null, { params: { entity, id } })
      ElMessage.success(`${action}成功`)
      loadData()
    })
    .catch(() => {})
}

const handleRemoveRow = (row) => {
  if (!row) return
  const id = row[schema.value.idField || 'id']
  if (!id) return
  ElMessageBox.confirm('确认删除该记录？', '提示', { type: 'warning' })
    .then(async () => {
      await axios.post(schema.value.removeApi, null, { params: { ids: String(id) } })
      ElMessage.success('删除成功')
      loadData()
    })
    .catch(() => {})
}

const auditDialogVisible = ref(false)
const auditDialogRecord = ref(null)

// 发货弹窗
const shipDialogVisible = ref(false)
const shipLoading = ref(false)
const shipForm = ref({
  orderId: '',
  orderType: 'order',
  shipments: []
})
const expressOptions = ref([])
let shipmentLocalKey = 0

const createShipmentRow = (source = {}) => ({
  id: source.id || '',
  expressSn: source.expressSn || source.express_sn || '',
  expressCode: source.expressCode || source.express_code || '',
  expressName: source.expressName || source.express_name || '',
  localKey: `shipment-${++shipmentLocalKey}`
})

const copyTextToClipboard = async (text, successMsg) => {
  if (!text) return
  try {
    await navigator.clipboard.writeText(text)
  } catch (err) {
    const textarea = document.createElement('textarea')
    textarea.value = text
    textarea.style.position = 'fixed'
    textarea.style.opacity = '0'
    document.body.appendChild(textarea)
    textarea.select()
    document.execCommand('copy')
    document.body.removeChild(textarea)
  }
  ElMessage.success(successMsg)
}

const copyProductCode = (row) => {
  const code = row?.code
  if (!code) return
  copyTextToClipboard(code, '商品编码已复制')
}

const copyAuditCode = async () => {
  const code = auditDialogRecord.value?.code
  if (!code) return
  await copyTextToClipboard(code, '审核编号已复制')
}

const loadExpressOptions = async () => {
  try {
    const res = await axios.get('/api/delivery-expresses/list', { params: { current: 1, size: 200 } })
    if (res.data && (res.data.code === 1 || res.data.code === 200)) {
      expressOptions.value = (res.data.data?.records || res.data.data?.list || []).map(item => ({
        id: item.id,
        code: item.code,
        name: item.name || item.code
      }))
    }
  } catch (e) {
    console.error('加载物流公司失败', e)
  }
}

const handleShipRow = async (row, orderType = 'order') => {
  if (!row) return
  const id = row[schema.value.idField || 'id']
  if (!id) return
  shipForm.value = {
    orderId: String(id),
    orderType,
    shipments: []
  }
  try {
    const shipmentUrl = orderType === 'lottery' ? '/api/lottery-orders/shipments' : '/api/order/shipments'
    const shipmentParams = orderType === 'lottery' ? { id } : { orderId: id }
    const [, shipmentRes] = await Promise.all([
      loadExpressOptions(),
      axios.get(shipmentUrl, { params: shipmentParams })
    ])
    const records = shipmentRes.data?.data || []
    shipForm.value.shipments = Array.isArray(records) && records.length
      ? records.map(createShipmentRow)
      : [createShipmentRow({
          expressSn: row.expressSn || row.express_sn || row.expressNo || row.express_no || '',
          expressCode: row.expressCode || row.express_code || '',
          expressName: row.expressName || row.express_name || row.expressCompany || row.express_company || ''
        })]
  } catch (e) {
    console.error('加载发货信息失败', e)
    shipForm.value.shipments = [createShipmentRow({
      expressSn: row.expressSn || row.express_sn || row.expressNo || row.express_no || '',
      expressCode: row.expressCode || row.express_code || '',
      expressName: row.expressName || row.express_name || row.expressCompany || row.express_company || ''
    })]
  }
  shipDialogVisible.value = true
}

const addShipmentRow = () => {
  shipForm.value.shipments.push(createShipmentRow())
}

const removeShipmentRow = (index) => {
  shipForm.value.shipments.splice(index, 1)
}

const onExpressChange = (index, code) => {
  const item = expressOptions.value.find(i => i.code === code)
  const shipment = shipForm.value.shipments[index]
  if (shipment) shipment.expressName = item ? item.name : ''
}

const submitShip = async () => {
  if (!shipForm.value.orderId) return
  const shipments = shipForm.value.shipments.map(item => ({
    id: item.id || undefined,
    expressSn: String(item.expressSn || '').trim(),
    expressCode: String(item.expressCode || '').trim(),
    expressName: item.expressName || item.expressCode
  }))
  const incompleteIndex = shipments.findIndex(item => !item.expressCode || !item.expressSn)
  if (incompleteIndex >= 0) {
    ElMessage.warning(`请填写完整的包裹 ${incompleteIndex + 1} 信息`)
    return
  }
  const shipmentKeys = shipments.map(item => `${item.expressCode.toLowerCase()}|${item.expressSn}`)
  if (new Set(shipmentKeys).size !== shipmentKeys.length) {
    ElMessage.warning('存在重复的物流公司和运单号')
    return
  }
  shipLoading.value = true
  try {
    const submitUrl = shipForm.value.orderType === 'lottery' ? '/api/lottery-orders/ship' : '/api/order/self-ship'
    const res = await axios.post(submitUrl, {
      orderId: shipForm.value.orderId,
      shipments
    })
    if (res.data && (res.data.code === 1 || res.data.code === 200)) {
      ElMessage.success('发货成功')
      shipDialogVisible.value = false
      loadData()
    } else {
      ElMessage.warning(res.data?.msg || '发货失败')
    }
  } catch (e) {
    ElMessage.error(e?.response?.data?.msg || '发货失败')
  } finally {
    shipLoading.value = false
  }
}

const formatAuditStatus = (status) => {
  if (status === 0) return '待审核'
  if (status === 1) return '已通过'
  if (status === 2) return '已驳回'
  return '-'
}

const formatDateTime = (value) => {
  if (!value) return '-'
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return '-'
  return date.toLocaleString()
}

const handleViewAudit = async (row) => {
  if (!row) return
  const id = row[schema.value.idField || 'id']
  if (!id) return

  try {
    const res = await axios.get('/api/audit-records/list', {
      params: {
        schemaCode: 'Product',
        businessId: id,
        current: 1,
        size: 10
      }
    })

    const records = res?.data?.data?.records || []
    if (records.length === 0) {
      ElMessage.info('暂无审核记录')
      return
    }

    const record = records[0]
    auditDialogRecord.value = record
    auditDialogVisible.value = true
  } catch (error) {
    ElMessage.error('获取审核信息失败：' + (error.response?.data?.msg || error.message))
  }
}

const sanitizePayload = (data = {}) => {
  const payload = { ...data }
  const toRelativeUrl = (url) => {
    if (!url) return ''
    const str = String(url)
    try {
      const u = new URL(str)
      return u.pathname + u.search + u.hash
    } catch {
      return str
    }
  }
  const isUploadField = (field) => {
    if (!field) return false
    const t = mapType(field.type)
    if (t === 'upload' || t === 'image') return true
    const comp = String(field.component || '').toLowerCase()
    return comp.includes('upload') || comp.includes('image')
  }
  const pickUrl = (v) => {
    if (!v) return ''
    if (typeof v === 'string') return v
    if (typeof v === 'object') {
      if (v.url) return v.url
      if (v.src) return v.src
      if (v.response) {
        if (typeof v.response === 'string') return v.response
        if (v.response.url) return v.response.url
        if (v.response.data) {
          if (typeof v.response.data === 'string') return v.response.data
          if (v.response.data.url) return v.response.data.url
        }
      }
      if (v.data) {
        if (typeof v.data === 'string') return v.data
        if (v.data.url) return v.data.url
      }
    }
    return ''
  }
  ;(schema.value.formFields || []).forEach((f) => {
    if (!f) return
    // 跳过子表字段，子表数据通过 parentField 直接传递
    if (f.isSubTable) return
    const key = f.prop
    if (key === undefined || !(key in payload)) return
    let v = payload[key]
    const isUploadMulti = isUploadField(f) && !!f.multiple
    if (Array.isArray(v)) {
      if (isUploadField(f)) {
        const urls = v
          .map((item) => toRelativeUrl(pickUrl(item)))
          .filter((u) => u && !String(u).startsWith('blob:'))
        v = isUploadMulti ? urls : urls[0] || ''
      } else if (mapType(f.type) === 'category-tree') {
        v = v.map((item) => String(item ?? '').trim()).filter(Boolean).join(',')
      } else {
        v = v[0]
      }
    }
    if (isUploadField(f) && typeof v === 'object') {
      const url = toRelativeUrl(pickUrl(v))
      if (isUploadMulti) {
        v = url && !String(url).startsWith('blob:') ? [url] : []
      } else {
        v = url && !String(url).startsWith('blob:') ? url : ''
      }
    }
    // 确保上传字段的字符串URL也转为相对路径
    if (isUploadField(f) && typeof v === 'string' && v.startsWith('http')) {
      v = toRelativeUrl(v)
    }
    if (isUploadField(f) && Array.isArray(v)) {
      v = v.map((u) => typeof u === 'string' && u.startsWith('http') ? toRelativeUrl(u) : u)
    }
    if (isUploadField(f) && isUploadMulti && Array.isArray(v)) {
      v = v.filter(Boolean).join(',')
    }
    if (isDateTimeFieldType(f.type)) {
      v = normalizeDateTimeForSubmit(v)
    } else if (isDateFieldType(f.type)) {
      v = normalizeDateForSubmit(v)
    }
    // 额外处理：如果字段包含 icon/img/image 关键字，确保过滤 blob URL
    const lk = key.toLowerCase()
    if ((lk.includes('icon') || lk.includes('img') || lk.includes('image')) && typeof v === 'string' && v.startsWith('blob:')) {
      v = ''
    }
    if (!isUploadMulti && mapType(f.type) === 'number' && v !== '' && v !== null && v !== undefined) {
      const num = Number(v)
      v = Number.isNaN(num) ? v : num
    }
    payload[key] = v
  })
  // 元数据未标 datetime 时，按字段名兜底转换（改时间后 date-picker 会输出空格格式）
  Object.keys(payload).forEach((key) => {
    if (!KNOWN_DATETIME_PROPS.has(String(key).toLowerCase())) return
    payload[key] = normalizeDateTimeForSubmit(payload[key])
  })
  if (payload.previewImages != null && payload.previewImages !== '') {
    const parts = Array.isArray(payload.previewImages)
      ? payload.previewImages
      : String(payload.previewImages).split(',')
    payload.previewImages = parts
      .map((u) => toRelativeUrl(String(u || '').trim()))
      .filter((u) => u && !String(u).startsWith('blob:'))
      .join(',')
  }
  return payload
}

const LOTTERY_COPY_RESET = {
  participantCount: 0,
  isDrawn: 0,
  currentRoundDrawCount: 0,
  currentDrawCount: 0,
  round: 1,
  hasWonHeadInCurrentRound: 0,
  createTime: null,
  updateTime: null,
  createUser: null,
  updateUser: null,
}

const applyLotteryCopyDefaults = (copy) => {
  Object.assign(copy, LOTTERY_COPY_RESET)
  Object.keys(copy).forEach((key) => {
    if (key.endsWith('Desc')) delete copy[key]
  })
  delete copy.createUserName
  delete copy.updateUserName
  if (Array.isArray(copy.lotteryActivityPrizes)) {
    copy.lotteryActivityPrizes = copy.lotteryActivityPrizes.map((row) => {
      const next = { ...row }
      delete next.id
      delete next.activityId
      return next
    })
  }
  if (Array.isArray(copy.LotteryActivityPrize)) {
    copy.LotteryActivityPrize = copy.LotteryActivityPrize.map((row) => {
      const next = { ...row }
      delete next.id
      delete next.activityId
      return next
    })
  }
  return copy
}

const LOTTERY_SUBMIT_STRIP_KEYS = [
  'createTime', 'updateTime', 'createUser', 'updateUser', 'isDeleted', 'deletedAt',
  'createUserName', 'updateUserName',
  'prizeTypeDesc', 'enableWaitlistDesc', 'auditStatusDesc', 'isDrawnDesc',
  'needLoginDesc', 'stockLockStrategyDesc',
  // 运行时统计字段，由参与/开奖逻辑维护，不应由表单提交覆盖
  'participantCount', 'currentRoundDrawCount', 'currentDrawCount', 'hasWonHeadInCurrentRound',
]

const PRODUCT_SUBMIT_STRIP_KEYS = [
  'createTime', 'updateTime', 'createUser', 'updateUser', 'isDeleted',
  'createUserName', 'updateUserName', 'designerName', 'signDesignerName', 'signDesignerImage',
]

const AUDIT_SUBMIT_STRIP_KEYS = [
  'createTime', 'updateTime', 'createUser', 'updateUser', 'isDeleted', 'deletedAt',
  'createUserName', 'updateUserName',
]

const stripAuditFieldsDeep = (payload) => {
  if (!payload || typeof payload !== 'object') return payload
  AUDIT_SUBMIT_STRIP_KEYS.forEach((key) => { delete payload[key] })
  Object.keys(payload).forEach((key) => {
    if (!Array.isArray(payload[key])) return
    payload[key] = payload[key].map((row) => {
      if (!row || typeof row !== 'object') return row
      const next = { ...row }
      AUDIT_SUBMIT_STRIP_KEYS.forEach((k) => { delete next[k] })
      return next
    })
  })
  return payload
}

const stripProductSubmitPayload = (payload) => {
  PRODUCT_SUBMIT_STRIP_KEYS.forEach((key) => { delete payload[key] })
  if (Array.isArray(payload.specs)) {
    payload.specs = payload.specs.map((row) => {
      const next = { ...row }
      PRODUCT_SUBMIT_STRIP_KEYS.forEach((key) => { delete next[key] })
      return next
    })
  }
  return payload
}

const LOTTERY_NUMERIC_PROPS = new Set([
  'id', 'prizecount', 'prizetype', 'participantcount', 'prizevaliddays', 'enablewaitlist',
  'maxjointimesperuser', 'needlogin', 'auditstatus', 'stocklockstrategy', 'operatorid',
  'isdrawn', 'drawtype', 'weigh', 'status', 'designid', 'couponid', 'isdeleted',
  'designerid', 'guaranteedquantity', 'currentrounddrawcount', 'round',
  'haswonheadincurrentround', 'finalguaranteedquantity', 'currentdrawcount',
  'consolationcouponid', 'points',
])

const cleanLotteryActivityPayload = (payload) => {
  LOTTERY_SUBMIT_STRIP_KEYS.forEach((key) => { delete payload[key] })
  Object.keys(payload).forEach((key) => {
    if (key.endsWith('Desc')) delete payload[key]
    const v = payload[key]
    if (v !== '') return
    if (LOTTERY_NUMERIC_PROPS.has(String(key).toLowerCase())) {
      payload[key] = null
    }
  })
  if (payload.id !== undefined && payload.id !== null && payload.id !== '') {
    const idNum = Number(payload.id)
    if (!Number.isNaN(idNum)) payload.id = idNum
  } else {
    payload.isDrawn = 0
    payload.round = payload.round || 1
  }
  return payload
}

const normalizeConfigSwitchValue = (val) => {
  if (val === 1 || val === '1' || val === true) return '1'
  return '0'
}

const submitForm = (targetStatus) => {
  if (!formRef.value) return
  formRef.value.validate(async (valid) => {
    if (!valid) return
    submitLoading.value = true
    try {
      console.log('提交前 form.value:', JSON.parse(JSON.stringify(form.value)))
      const payload = sanitizePayload(form.value)
      console.log('sanitizePayload 后 payload:', JSON.parse(JSON.stringify(payload)))
      const pk = schema.value.idField || 'id'
      if (form.value && form.value[pk] !== undefined) payload[pk] = form.value[pk]
      
      // 商品表单：保存不提交审核，新增默认草稿由后端处理；编辑时不改 status
      if (props.formCode === 'Product') {
        delete payload.status
      }

      // 商品表单：添加商品类型
      if (props.formCode === 'Product' && currentProductType.value !== null && currentProductType.value !== undefined) {
        payload.productType = currentProductType.value
      }

      if (isLotteryActivityForm.value) {
        payload.drawType = currentLotteryDrawType.value ?? payload.drawType ?? 1
        cleanLotteryActivityPayload(payload)
      }

      if (props.formCode === 'Article') {
        if (payload.content) {
          payload.content = stripHtmlToPlainText(payload.content)
        }
        if (!Array.isArray(payload.contentImages)) {
          payload.contentImages = payload.contentImages ? [payload.contentImages].filter(Boolean) : []
        }
      }
      
      // 商品规格：子表 parentField -> specs 提交给后端
      if (props.formCode === 'Product') {
        mapProductSpecsToSubmitPayload(payload)
        stripProductSubmitPayload(payload)
      }

      stripAuditFieldsDeep(payload)

      // LotteryActivityPrize 子表字段名映射为 lotteryActivityPrizes
      if (props.formCode === 'LotteryActivity' && payload.LotteryActivityPrize) {
        payload.lotteryActivityPrizes = payload.LotteryActivityPrize
        delete payload.LotteryActivityPrize
      }
      
      console.log('最终提交 payload:', JSON.parse(JSON.stringify(payload)))
      await axios.post(schema.value.submitApi, payload)
      if (props.formCode === 'Config') {
        const configName = String(payload.name || payload.configKey || '')
        if (String(payload.type) === '4') {
          payload.value = normalizeConfigSwitchValue(payload.value)
        }
        if (configName.startsWith('site.')) {
          await refreshSiteConfig()
        }
      }
      const successMsg = '保存成功'
      ElMessage.success(successMsg)
      mode.value = 'list'
      current.value = null
      selectedIds.value = []
      loadData()
    } catch (error) {
      const msg = error?.response?.data?.msg
        || error?.response?.data?.message
        || error?.response?.data?.error
        || error?.message
        || '保存失败'
      ElMessage.error(msg)
      console.error('提交失败', error?.response?.data || error)
    } finally {
      submitLoading.value = false
    }
  })
}

const backToList = () => {
  specsSubTableLoading.value = false
  if (resolveInitMode() === 'form' && route.meta?.listPath) {
    router.push(route.meta.listPath)
    return
  }
  mode.value = 'list'
  formRef.value?.clearValidate?.()
  loadData()
}

const loadProductTypes = async () => {
  if (props.formCode !== 'Product') return
  try {
    await ensureFormConfigs()
    productTypeOptions.value = buildProductTypeOptionsFromConfigs(formConfigs.value)
  } catch (e) {
    console.warn('加载商品类型失败', e)
  }
}

onMounted(async () => {
  await mergeConfig()
  await loadProductTypes()
  if (resolveInitMode() === 'form') {
    enterAddFormMode()
  } else {
    loadData()
  }
})

watch(
  () => [props.formCode, props.lotteryDrawType],
  async () => {
    page.value.current = 1
    lotteryTabInitialized.value = false
    lotteryStatusTab.value = 'all'
    await mergeConfig()
    await loadProductTypes()
    await loadData()
  }
)

watch(
  () => currentProductType.value,
  async (newType, oldType) => {
    if (props.formCode === 'Product' && newType !== oldType && newType !== null && newType !== undefined) {
      await mergeConfig()
    }
  }
)

watch(
  () => route.fullPath,
  async () => {
    selectedIds.value = []
    if (resolveInitMode() === 'form') {
      await mergeConfig()
      enterAddFormMode()
      return
    }
    mode.value = 'list'
    current.value = null
    formRef.value?.clearValidate?.()
    loadData()
  }
)
</script>

<style scoped>
.shipment-form-item {
  padding: 14px 14px 2px;
  margin-bottom: 12px;
  background: #f7f8fa;
  border-radius: 6px;
}
.shipment-form-item__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 28px;
  margin-bottom: 10px;
  font-weight: 600;
  color: #303133;
}
.shipment-add-button {
  width: 100%;
}
.list-cell-text {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}
.audit-dialog {
  padding: 12px 0 6px;
}
.audit-dialog__row {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}
.audit-dialog__row .label {
  width: 80px;
  font-weight: 600;
}
.audit-dialog__row .value {
  flex: 1;
}
.audit-dialog__row .copy-icon {
  margin-left: 6px;
}
.audit-dialog__row .copy-link {
  font-size: 14px;
  margin-left: 6px;
  color: #409eff;
  cursor: pointer;
}
.product-list-thumb-wrap {
  position: relative;
  display: inline-block;
  width: 56px;
  height: 56px;
  border-radius: 6px;
  border: 1px solid #f0f0f0;
  overflow: hidden;
  cursor: pointer;
  vertical-align: middle;
}
.product-list-thumb {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.product-list-thumb__mask {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.45);
  opacity: 0;
  transition: opacity 0.2s ease;
}
.product-list-thumb-wrap:hover .product-list-thumb__mask {
  opacity: 1;
}
.product-list-thumb__icon {
  font-size: 20px;
  color: #fff;
}
.product-list-thumb--empty {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 6px;
  border: 1px dashed #e5e7eb;
  color: #9ca3af;
  font-size: 12px;
}
.product-info-cell {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 4px 0;
}
.product-info-cell__media {
  flex-shrink: 0;
}
.product-info-cell__body {
  min-width: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
}
.product-info-cell__name {
  font-size: 14px;
  font-weight: 500;
  color: #111827;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.product-info-cell__code-row {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  max-width: 100%;
}
.product-info-cell__code {
  font-size: 12px;
  color: #9ca3af;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.product-info-cell__copy {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  padding: 0;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: #9ca3af;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.15s ease, color 0.15s ease, background 0.15s ease;
}
.product-info-cell__code-row:hover .product-info-cell__copy {
  opacity: 1;
}
.product-info-cell__copy:hover {
  color: #2563eb;
  background: #eff6ff;
}
.product-info-cell__copy .el-icon {
  font-size: 14px;
}
.product-info-cell__preview {
  margin-top: 2px;
  padding: 2px 8px;
  font-size: 12px;
  color: #6b7280;
  background: #f3f4f6;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  line-height: 1.5;
}
.product-info-cell__preview:hover {
  color: #2563eb;
  background: #eff6ff;
}
.product-sales-cell__main {
  font-size: 16px;
  font-weight: 600;
  color: #111827;
  line-height: 1.3;
}
.product-sales-cell__sub {
  margin-top: 4px;
  font-size: 12px;
  color: #9ca3af;
  line-height: 1.2;
}
.form-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  width: 100%;
  box-sizing: border-box;
}
.form-shell {
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  height: 100%;
  background: #fff;
  overflow: hidden;
}
.form-body-card {
  flex: 1;
  min-width: 0;
  min-height: 0;
  overflow-y: auto;
  padding: 16px 20px 20px;
  background: #fff;
  box-sizing: border-box;
}
.form-body-card :deep(.el-form) {
  width: 100%;
  box-sizing: border-box;
}
.form-body-card :deep(.el-form-item) {
  width: 100%;
  max-width: none;
  box-sizing: border-box;
  align-items: stretch;
  margin-bottom: 4px;
}
.form-body-card :deep(.el-form--label-top .el-form-item__label) {
  width: 100% !important;
  max-width: 100%;
  overflow: visible;
  height: auto;
  line-height: 1.45;
  white-space: normal;
  word-break: break-word;
  text-align: left;
  justify-content: flex-start;
  padding: 0 0 4px;
  margin-bottom: 0;
  float: none;
}
.form-body-card :deep(.el-form--label-top .field-label) {
  color: #374151;
  font-weight: 600;
  font-size: 13px;
}
.form-body-card :deep(.el-form-item__content) {
  flex: 0 0 auto;
}
.form-body-row {
  display: flex;
  flex: 1;
  min-height: 0;
  align-items: stretch;
  width: 100%;
  box-sizing: border-box;
}
.form-side {
  flex: 0 0 200px;
  width: 200px;
  border-right: 1px solid var(--bymy-color-border);
  padding: 12px 10px;
  overflow-y: auto;
  background: #fff;
  box-sizing: border-box;
}
.form-nav {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.form-nav__item {
  padding: 9px 12px;
  border-radius: 8px;
  background: transparent;
  color: #374151;
  cursor: pointer;
  transition: color 0.15s ease, background-color 0.15s ease;
  user-select: none;
  font-size: 14px;
}
.form-nav__item:hover {
  background: rgba(15, 23, 42, 0.04);
  color: #111827;
}
.form-nav__item.active {
  background: transparent;
  color: var(--bymy-color-primary);
  font-weight: 600;
}
.form-panel :deep(.group-card) {
  border: none;
  box-shadow: none;
  border-radius: 0;
  padding: 0 0 20px;
  margin-bottom: 20px;
  border-bottom: 1px solid var(--bymy-color-border);
  background: transparent;
}
.form-panel :deep(.group-card:last-child) {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}
.form-panel :deep(.group-title) {
  font-size: 15px;
  font-weight: 700;
  color: #111827;
  margin-bottom: 16px;
}
.form-body-card :deep(.meta-form-renderer) {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}
.form-panel__header {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 20px;
  border-bottom: 1px solid var(--bymy-color-border);
}
.form-panel__header .back {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #409eff;
  cursor: pointer;
  font-weight: 500;
  font-size: 16px;
}
.form-panel__header .back-icon {
  font-size: 16px;
}
.form-panel__header .title {
  font-size: 16px;
  font-weight: 600;
}
.form-footer-bar {
  flex-shrink: 0;
  border-top: 1px solid var(--bymy-color-border);
  padding: 10px 20px 12px;
  background: #fff;
}
.form-body-card :deep(.meta-form-renderer) {
  width: 100%;
  max-width: none;
}
.form-footer__inner {
  display: flex;
  justify-content: center;
  gap: 12px;
}
</style>
